import enLocale from "../../../node_modules/element-ui/lib/locale/lang/en";
const en = {
  // 头部
  navbar: {
    home: "Home",
    list: [
      {
        name: " Account Information",
        type: 1,
        img: require("../../assets/img/login/account.png")
      },
      {
        name: "Logout",
        type: 3,
        img: require("../../assets/img/login/out.png")
      }
    ],
    login: "Login",
    register: "Register",
    logOut: "Logout",
    accountInformation: "Account Information",
    ProductSystem: "Product & Service",
    solution: "Solutions",
    price: "Price",
    AboutUs: "About us",
    title:"Build Unlimited Connectivity",
    dropList: [
      {
        name: "MSP",
        names: "MSP",
        img1: require("../../assets/img/header/DCI.png"),
        img: require("../../assets/img/header/DCI.png"),
        imgs: require("../../assets/img/header/DCI2.png"),
        type: 1
      },
      {
        name: "SD-Cloud", // Cloud Dedicated Line
        names: "SD-Cloud 1",
        img1: require("../../assets/img/header/cloud1.png"),
        img: require("../../assets/img/header/cloud1.png"),
        imgs: require("../../assets/img/header/cloud.png"),
        type: 2
      },
      {
        name: "DA",
        names: "DA",
        img1: require("../../assets/img/header/speed.png"),
        img: require("../../assets/img/header/speed.png"),
        imgs: require("../../assets/img/header/speed2.png"),
        type: 3
      },
      {
        name: "SD-WAN",
        names: "SD-WAN",
        img1: require("../../assets/img/header/SD-WAN.png"),
        img: require("../../assets/img/header/SD-WAN.png"),
        imgs: require("../../assets/img/header/SD-WAN2.png"),
        type: 4
      }
    ],
    solutList: [
      {
        name: "Hybrid Cloud Services",
        img1: require("../../assets/img/header/headhunhe.png"),
        img: require("../../assets/img/header/headhunhe.png"),
        imgs: require("../../assets/img/header/headhunhe2.png"),
        type: 1
      },
      {
        name: "Enterprise Private Network",
        img1: require("../../assets/img/header/headsiyou.png"),
        img: require("../../assets/img/header/headsiyou.png"),
        imgs: require("../../assets/img/header/headsiyou2.png"),
        type: 2
      }
    ],
    aboutus: [
      {
        name: "Introductions",
        img1: require("../../assets/img/header/conpy1.png"),
        img: require("../../assets/img/header/conpy1.png"),
        imgs: require("../../assets/img/header/conpy2.png"),
        type: 1
      },
      {
        name: "Promises",
        img1: require("../../assets/img/header/serve1.png"),
        img: require("../../assets/img/header/serve1.png"),
        imgs: require("../../assets/img/header/serve2.png"),
        type: 2
      }
    ]
  },
  // 底部
  footer: {
    Services: "Contact us",
    phonetext: "365x7x24 Service Hotline:",
    telphone: "852-5123-4372",
    address:
      "Address:Room 19, 12 / F, good view business centre, 2-16 Garden Street, Mongkok, Kowloon, Hong Kong",
    email: "Mail:noc@zhtd.hk",
    saleemail:"Sales Mail:sales@zhtd.hk",
    productSystem: "Product & Service",
    DCIInterconnected: "SD-DCI",
    CloudLine: "SD-Cloud",
    DirectionalAcceleration: "DA",
    SDWAN: "SD-WAN",
    solution: "Solutions",
    cloud: "Hybrid Cloud Services",
    conty: "Enterprise Private Network",
    about: "About us",
    intro: "Introductions",
    service: "Promises",
    weixin: "Follow us in Wechat"
  },
  // 首页
  main: {
    title: "High-speed Reliable Secure",
    text:
      "Build a DC-to-DC, DC-to-Cloud, Cloud-to-Cloud seamless connectivity based on SDN enable TESUCH Global Global Network",
    texttitle:
      "TESUCH Global is committed to creating a leading china ecological network service, and adheres to the corporate values of customer first, innovation, pragmatism and never forgetting its origin and sincerity.",
    texttitles:
      "Based on the characteristics of the industry, TESUCH Global takes security as the first, stability as the basis, integrates industry resources, provides targeted solutions for all industries, and lays out the ecological network platform.",
    product: "Product Introduction",
    textlist: [
      {
        name: "DCI",
        img: require("../../assets/img/main/DCI.png"),
        title:
          "High-speed, secure and stable dedicated connection service, based on TESUCH Global SDN network to meet the interconnection requirements of DC-DC in different areas of the network.",
        btn: "Learn more",
        type: 1
      },
      {
        name: "SD-Cloud",
        img: require("../../assets/img/main/cloud.png"),
        title:
          "High-speed, secure and stable dedicated line connection service, based on the TESUCH Global SDN platform to meet the interconnection needs of PoP - public cloud, public cloud - public cloud.",
        btn: "Learn more",
        type: 2
      },
      {
        name: "DA",
        img: require("../../assets/img/main/JS.png"),
        title:
          "Directional acceleration is a high-speed, secure and stable dedicated connection service provided by TESUCH Global. Based on TESUCH Global SDN platform, it can meet the needs of directional acceleration in different regions of the network.",
        btn: "Learn more",
        type: 3
      },
      {
        name: "SD-WAN",
        img: require("../../assets/img/main/SD-WAN.png"),
        title:
          "High-speed, secure, and stable connection services, based on the TESUCH Global SD-WAN network to meet the interconnection needs of different regions in the network.",
        btn: "Learn more",
        type: 4
      }
    ],
    case: "Customer Case",
    caselist: [
      {
        name: "DCI Product Case",
        img: require("../../assets/img/main/DCIcase.png"),
        title:
          "Based on TESUCH Global SDN high-availability network to meet the interconnection needs of customers in different data centers.",
        type: 1
      },
      {
        name: "SD-Cloud Product Case",
        img: require("../../assets/img/main/cloudCase.png"),
        title:
          "To help companies quickly build high-quality private networks connected to the public cloud.",
        type: 2
      },

      {
        name: "DA Product Case",
        img: require("../../assets/img/main/speedCase.png"),
        title:
          "Based on TESUCH Global SDN high-availability network to meet the directional acceleration needs of customers in different data centers.",
        type: 3
      },
      {
        name: "SD-WAN Product Case",
        img: require("../../assets/img/main/SD-WANcase.png"),
        title:
          "Based on TESUCH Global SD-WAN high-availability network to meet the interconnection needs of customer headquarters and branch offices, helping enterprises to quickly network.",
        type: 4
      }
    ],
    create: "Build Unlimited Connectivity",
    partner: "Extend Partnership and Customer Oriented",
    serve: "Our Customers",
    join: "Our Partners",
    overseas: "Overseas cooperation infrastructure",
    open: "Developed area",
    data: [
      {
        name: "China",
        value: [104.195397, 35.86166, 1]
      },
      {
        name: "Japan",
        value: [139.252924, 39.204824]
      },
      {
        name: "South Korea",
        value: [127.766922, 35.907757]
      },
      {
        name: "France",
        value: [2.213749, 45.227638]
      },
      {
        name: "Germany",
        value: [14.451526, 48.165691]
      },
      {
        name: "America",
        value: [-95.712891, 37.09024]
      },
      {
        name: "Britain",
        value: [-2.235973, 56.378051]
      },
      {
        name: "Holland",
        value: [5.291265999999999, 52.132633]
      },
      {
        name: "Singapore",
        value: [101.975766, 4.210484]
      }
    ]
  },
  // 产品体系-DCI
  projectdci: {
    title: "MSP",
    text:
      "One Stop Cloud System Migration, Deployment and Monitoring Service",
    textlist: [
      {
        name: "Cloud Consulting",
        img: require("../../assets/img/product/spes.png")
      },
      {
        name: "Cloud Deployment",
        img: require("../../assets/img/product/stab.png")
      },
      {
        name: "Cloud Migration",
        img: require("../../assets/img/product/save.png")
      },
      {
        name: "Cloud Monitoring",
        img: require("../../assets/img/product/yun.png")
      }
    ],
    header: "MSP Introduction",
    matter:
      "Based on the in-depth cooperation with many cloud manufacturers at home and abroad, Tesuch provides customers with multi-scene cloud system service capabilities from cloud consulting to cloud monitoring.",
    about:
      "Tesuch will provide professional product use guidance from customer contact stage to product selection stage ,and offer mature business scheme design according to customer requirements",
    about2:
      "Tesuch can provide a landing implementation operation oriented to business application, and carry out corresponding application deployment operation for customer business architecture to meet the deployment scheme in various scenarios",
    about3:
      "Teusch designs targeted operation scheme and cloud migration management for different scenarios such as hybrid cloud, IDC cloud, cloud data migration, etc., to realize nearly lossless migration operation of users",
    about4:
      "According to the business application used by customers,  Tesuch provides a corresponding monitoring scheme to find problems in various aspects by the monitoring and dial test on the cloud",
    feature: "Product Features",
    spelist: [
      {
        name: "Multi-scene technology support capability",
        img: require("../../assets/img/product/04.png"),
        title:
          ""
      },
      {
        name: "Comprehensive application deployment capability",
        img: require("../../assets/img/product/05.png"),
        // TODO 范围调整？
        title:
          ""
      },
      {
        name: "Mature architecture migration capability",
        img: require("../../assets/img/product/06.png"),
        title: ""
      },
      {
        name: "Reliable problem finding capability",
        img: require("../../assets/img/product/01.png"),
        title: "Realize DC to nodes in as fast as THREE days."
      }
      // {
      //   name: "Configure on Demand",
      //   img: require("../../assets/img/product/02.png"),
      //   title:
      //     "1Mbps-10Gbps with adjustable bandwidth to support elastic growth."
      // },
      // {
      //   name: "Real-time Monitoring",
      //   img: require("../../assets/img/product/03.png"),
      //   title: "Real-time network monitoring and traffic reports service."
      // }
    ],
    scene: "Application Scenario",
    menustitle: "For Migration Schemes",
    text2: [
      {
        title:
          "Hot migration: A dedicated line needs to be built for clear module migration planning, with long time to cost, low impact for business and high risk in cloud migration."
      },
      {
        title:"Cold migration: Lossy business switching, with full switching after integration testing, short migration time, low risk in cloud migration."
      }
    ],
    menustitles: "For Migration Scenarios",
    menulists: [
      {
        title:
          "Cross-cloud migration: A large number of functional tests are required during the pre-sale POC phase for different cloud product functionality and device type adaptions."
      },
      {
        title:
          "IDC migration: The most common cloud migration mode, which only needs to confirm IDC business call logic. The migration is quite easy, and the sevice adaption can be provided according to cloud manufacturer's scheme"
      }
    ],
    case: "Customer Case",
    demand: "Customer Challenge",
    serviceList: [
      {
        name:
          "[MSP Pre-sale Scenario]Small financial customers who need to use cloud and local resources for hybrid cloud and local privatization deployment, require professional product use and selection suggestions, as well as consultation on architecture design scheme;"
      },
      {
        name:"[MSP in Sale Scenario]Financial customers who have confirmed to use cloud or private deployment, require deploying and migrating services with a lack of human resources and operational experience;"
      }
    ],
    solution: "Solutions",
    serviceLists: [
      {
        name:
          "Tesuch will provide professional service deployment consulting service in the pre-sale stage, guide users to separate business according to scenarios and services, and realize high cohesion, high availability and low coupling architecture logic;"
      },
      {
        name:
          "Tesuch can provide one-stop business deployment service in the process of sales, and help financial customers to easily complete the deployment of logic layer, data layer and network layer in multi-cloud environment and IDC environment;"
      }
    ]
  },
  projectcloud: {
    title: "SD-Cloud",
    text:
      "TESUCH Global provides high-speed, secure, and stable SD-Cloud services to achieve dedicated connections between data centers, private clouds, and public clouds",
    textlist: [
      {
        name: "High-speed Interworking",
        img: require("../../assets/img/product/spes.png")
      },
      {
        name: "Stable & Reliable",
        img: require("../../assets/img/product/stab.png")
      },
      {
        name: "Secure",
        img: require("../../assets/img/product/save.png")
      },
      {
        name: "Purchase on Demand",
        img: require("../../assets/img/product/buy.png")
      }
    ],
    header: "SD-Cloud Introduction",
    matter:
      "SD-Cloud is a high-speed, secure and stable dedicated connection service provided by TESUCH Global. Based on the TESUCH Global backbone network, it meets the interconnection needs of PoP - PoP, PoP - public cloud, public cloud - public cloud in different regions of the network. Combined with the last mile connection service, SD-Cloud can be extended to user office buildings or data centers, helping companies to quickly build high-quality private networks and achieve network convergence in various scenarios such as DCI and ECI.",
    about:
      "Relying on the TESUCH Global SDN high-availability network technology, the public clouds of different manufacturers can be connected, and high-speed intranet communication can be performed directly on both sides, eliminating the need to bypass the public network. Even if the two sides are thousands of miles apart, you can enjoy the low latency and high bandwidth of general intranet communications.",
    about2:
      "TESUCH Global SDN high availability network products rely on TESUCH Global global backbone network infrastructure to ensure the stable and reliable communication between your networks",
    about3:
      "TESUCH Global SDN high availability network communicates in the network virtualization layer, all communication data is transmitted in the self built facilities of TESUCH Global, and multi tenants are isolated from each other, so that your private data is free from the risk of being stolen in the transmission process",
    about4:
      "TESUCH Global SDN high availability network products provide different bandwidth specifications. You can purchase on demand according to your business needs, with controllable cost",
    feature: "Product Features",
    spelist: [
      {
        name: "Connect the full network by single point access",
        img: require("../../assets/img/product/04.png"),
        title:
          "Connect any node of TESUCH Global to get the connection conditions with multiple network providers. By expanding the bandwidth, enterprises can meet the request for incremental services and avoid employing multiple links."
      },
      {
        name: "Multi-region Access",
        img: require("../../assets/img/product/05.png"),
        // TODO 范围调整？
        title:
          "TESUCH Global provides more than 100 PoPs covering North China, East China, South China, Hong Kong, Macau, Taiwan and overseas. Enterprises can choose the nearest node access according to their business needs."
      },
      {
        name: "Multi-scenario Access",
        img: require("../../assets/img/product/07.png"),
        title:
          "SD-Cloud supports the interconnection of Alibaba Cloud, Tencent Cloud, AWS and other major public clouds and IDC nodes to meet the needs of enterprises' multi-scenario dedicated connection."
      },
      {
        name: "Quick Start",
        img: require("../../assets/img/product/01.png"),
        title:
          "TESUCH Global SDN high-availability network and public cloud, private cloud, industry cloud platform API automation docking fully support hybrid cloud network virtual private line interconnection customer self-service system, support one-click operation, second-level activation."
      },
      {
        name: "Configure on Demand",
        img: require("../../assets/img/product/02.png"),
        title:
          "Billing policy supported: fixed-broadband monthly billing policy, broadband + duration-based billing policy, traffic-based billing policy."
      },
      {
        name: "Real-time Monitoring",
        img: require("../../assets/img/product/03.png"),
        title: "Real-time network monitoring and traffic reports service"
      }
    ],
    scene: "Application Scenario",
    menustitle: "Dual-cloud & dual-active architecture",
    text2: [
      {
        title:
          "Based on TESUCH Global's backbone network and public cloud resources, the online integration of cross-cloud environments is realized through online self-help, helping the dual-cloud & dual-active architecture to land quickly."
      }
    ],
    menustitles: "Problems Solved",
    menulists: [
      {
        title:
          "Using dedicated connection throughout the process to ensure stable and high-speed network, real-time data synchronization, and improve user experience."
      },
      {
        title:
          "Using scheduling network resources on demand through TESUCH Global SDN high-availability network platform to achieve flexible network allocation."
      }
    ],
    case: "Customer Case",
    demand: "Customer Challenge",
    serviceList: [
      {
        name:
          "A customer needs directly connect to one public cloud from another public cloud."
      },
      {
        name:
          "Two 1G or 2G links are needed. Confirm different plans and quotes accordingly."
      },
      {
        //TODO 内容有问题？
        name:
          "The two 1G or 2G links are needed to have different transmission paths to achieve redundant mutual backup and load balancing."
      },
      {
        name:
          "Stabilize the basic network: through the stable and reliable characteristics of the metropolitan network, TESUCH Global can provide a fully redundant and highly available network architecture."
      }
    ],
    solution: "Solutions",
    serviceLists: [
      {
        name:
          "TESUCH Global SDN high-availability network are automatically docked with public cloud, private cloud, industry cloud platform API."
      },
      {
        name:
          "TESUCH Global SDN high-availability network can fully support hybrid cloud network virtual private interconnection"
      },
      {
        name:
          "Customer data will directly connect to the public cloud via TESUCH Global SDN high-availability network"
      },
      {
        name:
          "Customer services can communicate with public clouds through TESUCH Global SDN high-availability network"
      },
      {
        name: "Use link backup to minimize fault situations."
      }
    ]
  },
  projectDA: {
    title: "Directional Acceleration",
    text:
      "Local access to TESUCH Global SDN high availability network to resource pool",
    textlist: [
      {
        name: "High Speed Interworking",
        img: require("../../assets/img/product/spes.png")
      },
      {
        name: "Stable & Reliable",
        img: require("../../assets/img/product/stab.png")
      },
      {
        name: "Secure",
        img: require("../../assets/img/product/save.png")
      },
      {
        name: "Purchase on Demand",
        img: require("../../assets/img/product/buy.png")
      }
    ],
    header: "DA Introduction",
    matter:
      "DA (Directional Acceleration) is a high-speed, safe and stable special line connection service provided by TESUCH Global. Based on TESUCH Global SDN highly available network, it can meet the needs of DA in different regions of the network.",
    about:
      "Relying on the TESUCH Global SDN high-availability network technology, the public clouds of different manufacturers can be connected, and high-speed intranet communication can be performed directly on both sides, eliminating the need to bypass the public network. Even if the two sides are thousands of miles apart, you can enjoy the low latency and high bandwidth of general intranet communications.",
    about2:
      "TESUCH Global SDN high availability network products rely on TESUCH Global global backbone network infrastructure to ensure the stable and reliable communication between your networks",
    about3:
      "TESUCH Global SDN high availability network communicates in the network virtualization layer, all communication data is transmitted in the self built facilities of TESUCH Global, and multi tenants are isolated from each other, so that your private data is free from the risk of being stolen in the transmission process",
    about4:
      "TESUCH Global SDN high availability network products provide different bandwidth specifications. You can purchase on demand according to your business needs, with controllable cost",
    feature: "Pruduct Features",
    spelist: [
      {
        name: "Connect the full network by single point access",
        img: require("../../assets/img/product/04.png"),
        title:
          "Connect any node of TESUCH Global to get the connection conditions with multiple network providers. By expanding the bandwidth, enterprises can meet the request for incremental services and avoid employing multiple links."
      },
      {
        name: "Multi-region Access",
        img: require("../../assets/img/product/05.png"),
        title:
          "TESUCH Global provides more than 100 PoPs covering North China, East China, South China, Hong Kong, Macau, Taiwan and overseas. Enterprises can choose the nearest node access according to their business needs."
      },
      {
        name: "Visual Management",
        img: require("../../assets/img/product/06.png"),
        title: "Online self-service activation, business visual management"
      },
      {
        name: "Quick Start",
        img: require("../../assets/img/product/01.png"),
        title: "Realize DC to nodes in as fast as THREE days"
      },
      {
        name: "Configure on Demand",
        img: require("../../assets/img/product/02.png"),
        title:
          "1Mbps-10Gbps with adjustable bandwidth to support elastic growth"
      },
      {
        name: "Real-time Monitoring",
        img: require("../../assets/img/product/03.png"),
        title: "Real-time network monitoring and traffic reports service"
      }
    ],
    scene: "Application Scenario",
    menustitle: "",
    text2: [],
    menustitles: "Directional Acceleration",
    menulists: [
      {
        title:
          "Adopt TESUCH Global SDN high-availability network connection to directly access applications, improve network connection quality, reduce network latency and packet loss rate, and ensure a good application experience for customers."
      },
      {
        title:
          "Realize allocation of network resources and flexible management through TESUCH Global SDN high-availability network, and bear high concurrent access pressure."
      },
      {
        title:
          "TESUCH Global deploys IDC nodes and interconnected cloud nodes in multiple regions around the world, which can support the deployment of global server architecture."
      },
      {
        title:
          "TESUCH Global backbone network architecture can provide a secure tunnel and combines DDoS high defense to ensure network transmission security."
      }
    ],
    case: "Customer Case",
    demand: "Customer Challenge",
    serviceList: [
      {
        name: "Locations at both ends - A-end：Shenyang Z-end：Shenzhen"
      },
      {
        name:
          "The latency between PoPs shall be less than 85ms from Shenyang to Shenzhen."
      },
      {
        name: "The end-to-end bandwidth shall achieve 1Gbps."
      },
      {
        name: "A access to Tencent cloud server shall be provided in Shenzhen."
      }
    ],
    solution: "Solutions",
    serviceLists: [
      {
        name:
          "TESUCH Global connects the Shenyang Internet cafe with the Shenzhen POP node through the dedicated line."
      },
      {
        name:
          "TESUCH Global provides Shenzhen local Internet export for Shenyang Internet cafe users to access game servers in Shenzhen."
      },
      {
        name:
          "The Internet cafe can access the Shenzhen DCI through dedicated lines or local Internet."
      },
      {
        name:
          "The Internet cafe need to have equipment to distinguish between local game (network) routing and Shenzhen game routing."
      },
      {
        name:
          "All Shenzhen routes are accessed through TESUCH Global's dedicated connection."
      }
    ]
  },
  projectsd: {
    title: "SD-WAN",
    text: "Deploy an Easy Enterprise WAN Management Services",
    textlist: [
      {
        name: "High-speed interworking",
        img: require("../../assets/img/product/spes.png")
      },
      {
        name: "Stable & Reliable",
        img: require("../../assets/img/product/stab.png")
      },
      {
        name: "Secure",
        img: require("../../assets/img/product/save.png")
      },
      {
        name: "Purchase on Demand",
        img: require("../../assets/img/product/buy.png")
      }
    ],
    header: "SD-WAN Introduction",
    matter:
      "SD-WAN is a high-speed, secure and stable connection service, based on TESUCH Global SD-WAN network, it can meet the interconnection needs of different regions in the network. SD-WAN service can help enterprises to quickly build high-quality private networks, achieve office acceleration and networking of large group companies.",
    about:
      "Relying on TESUCH Global SDN high-availability network, the public clouds of different manufacturers can be connected, and high-speed intranet communication can be performed directly on both sides, eliminating the need to bypass the public network. Even if the two sides are thousands of miles apart, you can enjoy the low latency and high bandwidth of general intranet communications.",
    about2:
      "TESUCH Global SDN high availability network products rely on TESUCH Global global backbone network infrastructure to ensure the stable and reliable communication between your networks",
    about3:
      "TESUCH Global SDN high availability network communicates in the network virtualization layer, all communication data is transmitted in the self built facilities of TESUCH Global, and multi tenants are isolated from each other, so that your private data is free from the risk of being stolen in the transmission process",
    about4:
      "TESUCH Global SDN high availability network products provide different bandwidth specifications. You can purchase on demand according to your business needs, with controllable cost",
    feature: "Product Features",
    spelist: [
      {
        name: "Connect the full network by single point access.",
        img: require("../../assets/img/product/04.png"),
        title:
          "Connect any node of TESUCH Global to get the connection conditions with multiple network providers. By expanding the bandwidth, enterprises can meet the request for incremental services and avoid employing multiple links."
      },
      {
        name: "Multi-region Access",
        img: require("../../assets/img/product/05.png"),
        title:
          "TESUCH Global provides more than 100 PoPs covering North China, East China, South China, Hong Kong, Macau, Taiwan and overseas. Enterprises can choose the nearest node access according to their business needs.入"
      },
      {
        name: "Simple Network Management",
        img: require("../../assets/img/product/08.png"),
        title:
          "Automatically deploy traffic rules through a centralized portal, use a simple interface to set up and manage various network connections, realize real-time network status visualization, and quickly deploy with zero touch."
      },
      {
        name: "Quick Start",
        img: require("../../assets/img/product/09.png"),
        title:
          "After the customer network is connected to the SD-WAN device, the service is automatically opened."
      },
      {
        name: "Configure on Demand",
        img: require("../../assets/img/product/02.png"),
        title:
          "1Mbps-10Gbps with adjustable bandwidth to support elastic growth."
      },
      {
        name: "Real-time Monitoring",
        img: require("../../assets/img/product/03.png"),
        title: "Real-time network monitoring and traffic reports service."
      }
    ],
    scene: "Application Scenario",
    menustitle: "",
    text2: [],
    menustitles: "Large Company Networking",
    menulists: [
      {
        title:
          "For example, a large company has multiple branches throughout the country and uses TESUCH Global SD-WAN network to achieve group networking."
      },
      {
        title:
          "The customer deploys an TESUCH Global SD-WAN CE device and accesses the nearest SD-WAN PoP."
      },
      {
        title:
          "Use TESUCH Global SD-WAN CE device, based on the Internet to achieve the 'Last Mile' connection between branches and PoP locations of TESUCH Global."
      }
    ],
    case: "Customer Case",
    demand: "Customer Challenge",
    serviceList: [
      {
        name:
          "Provide cross-region and cross-network transmission through TESUCH Global SD-WAN network."
      }
    ],
    solution: "Solutions",
    serviceLists: [
      {
        name: "Deploy CPE nodes at the customer core (the headquarter or IDC)"
      },
      {
        name:
          "The branch nodes establish tunnels with TESUCH Global PoPs through the existing Internet."
      },
      {
        name:
          "Realize interconnection between various nodes through TESUCH Global SDN high-availability network."
      }
    ]
  },
  // 解决方案
  cloudSolution: {
    title: "Hybrid Cloud Solutions",
    text: "Realize a stable access to cloud",
    header: "Hybrid Cloud Solutions",
    master:
      "Relying on the hybrid cloud products such as public cloud and data centers connected by TESUCH Global Cloud, it provides full life cycle services for the design, deployment, implementation, security management, and intelligent operation and maintenance of hybrid cloud infrastructure, helping cutomers to quickly and easily build the hybrid cloud architecture they need.",
    businessRequire: "Business Request",
    businessList: [
      {
        name:
          "Achieve efficient interoperability between different resources such as public cloud, data centers, and private cloud."
      },
      {
        name:
          "Localize centralized public cloud resources and capabilities, improve computing efficiency, and improve user experience."
      },
      {
        name:
          "The hybrid cloud network architecture is more complex, which simplifies the landing process of the hybrid cloud infrastructure and requires higher network quality."
      }
    ],
    solutions: "Solutions",
    solutionList: [
      {
        name:
          "The public cloud cluster based on the TESUCH Global cloud dedicated line, deeply integrates the connection capabilities of the TESUCH Global and the hybrid cloud product service capabilities, creates a new ecosystem for the hybrid cloud industry, and facilitates the realization of data backup, data recovery and corresponding solutions."
      },
      {
        name:
          "Provide enterprises with full life cycle services of hybrid cloud infrastructure design, deployment and implementation, security and intelligent operation and maintenance, enabling enterprises to easily and quickly customize hybrid cloud solutions."
      }
    ],
    advantage: "Superiority",
    textlist: [
      {
        name: "Usability",
        img: require("../../assets/img/solute/01.png"),
        title:
          "Cloud computing does not guarantee that services will always function properly, but public clouds are often more available than most on-premises infrastructure. The built-in redundancy and Geo-replication with key data will be provided in the cloud.",
        type: 1
      },
      {
        name: "Agility",
        img: require("../../assets/img/solute/02.png"),
        title:
          "A hybrid cloud enables you to migrate resources and workloads from on-premises to the cloud and vice versa. For development and testing, hybrid cloud enables developers to easily get new virtual machines and applications without the assistance of IT operations staff.",
        type: 2
      },
      {
        name: "Cost Reduction",
        img: require("../../assets/img/solute/03.png"),
        title:
          "Cost reduction is one of the most attractive advantages of cloud computing, and it is also an important factor driving enterprise management to consider cloud services. Hybrid cloud can help enterprises reduce costs and use 'Pay As You Use' cloud computing resources to eliminate the need to purchase local resources.",
        type: 3
      },

      {
        name: "Extensibility",
        img: require("../../assets/img/solute/04.png"),
        title:
          "Hybrid cloud provides a cost-effective way for enterprises to expand storage. Compared with equivalent local storage, the cost of cloud storage is much lower. It is a good choice for backup, replication VM and data archiving. In addition, there is no pre cost and local resource request for increasing cloud storage.",
        type: 4
      }
    ],
    serve: "One-stop Hybrid Cloud Service",
    matterservice:
      "TESUCH Global provides professional business consulting, data center hosting, leased-line network interconnection, Internet bandwidth, hardware purchasing, and maintenance services to meet the network needs of different industries, and one-stop solution to corporate network problems.",
    mixtureline: "Hybrid Cloud Dedicated Line",
    mixturezoo: "Hybrid cloud Ecosystem",
    mixedcoud:
      "By utilizing the API, the public clouds can be interconnected in the TESUCH Global SDN high-availability network. Without offline operations, the agile delivery of the hybrid cloud private network can be achieved. In addition, the enterprise, data center and cloud can be quickly connected.",
    ecology:
      "TESUCH Global connects major cloud service providers, and cooperates with public cloud service providers such as Alibaba Cloud and Tencent Cloud to deeply customize complete hybrid cloud solutions."
  },
  contySolution: {
    title: "Enterprise Private Network",
    text:
      "High-speed interworking between company headquarters and branch network",
    header: "Enterprise Private Network",
    master:
      "Based on SD-WAN backbone network resources, TESUCH Global provides corporate headquarters and branch networking services to achieve high-speed and high-quality communications between branches in different regions and different sizes, to create a secure, collaborative, and interconnected office network, which greatly improves the company's Business interoperability of branch offices.",
    businessRequire: "Business Request",
    businessList: [
      {
        name:
          "Ensure the security and confidentiality of the corporate network and avoid internal data leakage."
      },
      {
        name:
          "Realize the resource sharing and data synchronization between the headquarters and the branches in real time to better ensure collaborative work."
      }
    ],
    solutions: "Solutions",
    solutionList: [
      {
        name:
          "With the help of TESUCH Global's widely covered global PoPs, enterprises can access nearby and complete the interconnection of branches in mainland and overseas regions."
      },
      {
        name:
          "TESUCH Global provides a hybrid network architecture, cross-data center leased line interconnection and hybrid cloud leased line interconnection services based on huge public cloud, data center and other resources to achieve a flexible and integrated infrastructure environment."
      }
    ],
    advantage: "Superiority",
    textlist: [
      {
        name: "Cost Reduction",
        img: require("../../assets/img/solute/05.png"),
        title:
          "Adopt TESUCH Global technology and use TESUCH Global SDN high-availability backbone network and SD-WAN products, with dedicated lines used by main applications and standby line used by non-main applicationsm, to save dedicated line traffic and reduce costs.",
        type: 1
      },
      {
        name: "Optimize Routing and Increase Availability",
        img: require("../../assets/img/solute/06.png"),
        title:
          "Through 'Dual-network Dual-use', the equipment/line/network is fully redundant to enhance the security and reliability of the network system.",
        type: 2
      },
      {
        name: "Taking Full Advantage of Resources",
        img: require("../../assets/img/solute/07.png"),
        title:
          "Based on TESUCH Global's backbone network technology, different applications can take different network lines, which will make full use of the existing network resources of the enterprise, and improve network bandwidth utilization.",
        type: 3
      },
      {
        name: "One-stop Hybrid Cloud Service",
        img: require("../../assets/img/solute/08.png"),
        title:
          "TESUCH Global provides one-stop services such as line and equipment application/installation/commissioning/operation and maintenance, and 7 * 24-hour expert operation and maintenance team after-sales support services to quickly respond to customer needs and solve problems.",
        type: 4
      }
    ],
    serve: "Enterprise Private Network Service",
    serviceList: [
      {
        img: require("../../assets/img/solute/alile.png"),
        title: "Flexible Networking",
        name:
          "Flexible networking methods can be provided according to the geographical distribution, scale, and actual network requirements of different branches of the enterprise; different access methods can be provided to connect to TESUCH Global PoPs, such as operator dedicated connection, bare fibers, SD-WAN, jumpers in IDC."
      },
      {
        img: require("../../assets/img/solute/global.png"),
        title: "Worldwide Service Coverage",
        name:
          "TESUCH Global covers more than 100 data center nodes around the world, and keep long-term cooperation with 30+ IDC service providers. TESUCH Global has constructed a huge resource pool, integrated backbone network resources, and has capacity to help enterprises achieve the extension of network capabilities in their respective regions in China and overseas."
      },
      {
        img: require("../../assets/img/solute/usebale.png"),
        title: "High Stablity & Usability",
        name:
          "Instead of the unreliability of the public Internet, TESUCH Global provides stable network access speed, and ensures high availability of services through route and protocol optimization. The network availability rate can reach 99.95%."
      },
      {
        img: require("../../assets/img/solute/network.png"),
        title: "Unified Network Management",
        name:
          "The network of the corporate headquarters and branch offices forms a complete network, which is convenient for the entire process to monitor and implement the self-switching of network failures, and achieve unified management and control of the corporate network."
      }
    ]
  },
  // 关于我们
  company: {
    title: "Tesuch Global Limited",
    text: "Create a Leading Ecological Network Service",
    header: "Tesuch Global Limited",
    about: "About us",
    aboutList: [
      {
        name:
          "Established in January 2013, dedicated to creating high-end telecommunications value-added service providers."
      },
      {
        name:
          "Services provided: china Internet access, china corporate VPN, DC-DC direct connection, DC-Cloud direct connection, SD-WAN connection, enterprise network maintenance, etc."
      },
      {
        name: "TESUCH Global supports SD-WAN-based hybrid cloud VPN access services."
      },
      {
        name:
          "TESUCH Global provides NOC operation and maintenance teams in Beijing, Guangzhou and Shanghai, 7x24x365 comprehensive operation and maintenance services."
      },
      {
        name:
          "TESUCH Global has launched cooperation with more than 30 companies in the same field in China to create a comprehensive and open ecological cooperation model."
      },
      {
        name:
          "TESUCH Global possessed a china fixed network transmission and value-added service operation license"
      }
    ],
    identity: "Certification",
    textlist: [
      {
        name: "Telegraphy",
        img: require("../../assets/img/us/identify07.png")
      }
    ],
    advantage: "Partners",
    look: "View More",
    retract: "Fold",
    serve: "Contact us",
    connect: [
      // TODO 信息修改
      {
        imgs: require("../../assets/img/us/04.png"),
        call: require("../../assets/img/us/CALL us.png"),
        phone: "365x7x24 Service Hotline：",
        tel: "+86 852-5123-4372",
        componey:"HongKong Company：Tesuch Global Limited",
        add:
          "Address：Room 19, 12 / F, good view business centre, 2-16 Garden Street, Mongkok, Kowloon, Hong Kong"
      }
    ],
    map:'(Sample graph)'
  },
  promise: {
    title: "TESUCH Global Insist in Cooperation",
    text: "Service First, Innovation and Sincerity Oriented",
    header: "Service System",
    textlist: [
      {
        name: "NOC Services",
        litext: [
          {
            title: "24 x 7 Proactive monitoring for equipment and network"
          },
          {
            title: "Problem analysis and fault management"
          },
          {
            title: "Performance, configuration, asset management"
          },
          {
            title: "Network dynamic analysis, reports, recommendations"
          }
        ],
        type: 1
      },
      {
        name: "Equipment Maintenance Services",
        litext: [
          {
            title: "On-site and spare parts service for multi-vendor products"
          },
          {
            title: "Event collection, correlation, and report"
          },
          {
            title: "Remote configuration"
          },
          {
            title: "Security report"
          },
          {
            title: "On-site engineers"
          }
        ],
        type: 3
      }
    ],
    textlists: [
      {
        name: "Telephone Technical Support Service",
        litext: [
          {
            title: "7 × 24 x 365 Service hotline at any time"
          },
          {
            title: "Multi-vendor product support, single point of contact"
          },
          {
            title: "Issue report"
          }
        ],
        type: 2
      },
      {
        name: "Corresponding SLA indicator for failure handling",
        litext: [
          {
            title: "First fault response phone - within 10 minutes"
          },
          {
            title: "First fault email - within 30 Minutes"
          },
          {
            title: "Fault progress feedback - within 60 minutes"
          }
        ],
        type: 4
      }
    ]
  },
  // 价格
  price: {
    title: "Connect at the click",
    header: "Create Your Connection",
    btnstart: "Create A-end",
    btnend: "Create Z-end",
    taptitle: "Inquire Price",
    texttitle: "Connection Test",
    band: "Bandwidth Range：",
    bandrange: [
      {
        id: "1",
        name: "Less than ",
        names: "100M",
        namesnum1: "",
        namesnum2: "100"
      },
      {
        id: "2",
        name: "100M",
        names: "-500M",
        namesnum1: "100",
        namesnum2: "500"
      },
      {
        id: "3",
        name: "500M",
        names: "-1G",
        namesnum1: "500",
        namesnum2: "1000"
      },
      {
        id: "4",
        name: "More than ",
        names: "1G",
        namesnum1: "1000",
        namesnum2: ""
      }
    ],
    selectband: "Bandwidth Choosing：",
    radio: "Other Requests",
    radios: "Submit to View Price",
    detail: "Configuration Details",
    startconfig: "A-end Configuration：",
    cloudtype: "Cloud Type:",
    country: "Country:",
    area: "Area:",
    data: "IDC:",
    endconfig: "Z-end Configuration：",
    basisconfig: "Basic Configuration：",
    bandline: "Bandwidth：",
    monthmoney: "Monthly Charges：",
    none: "Not Available for the Line",
    moneydetail: "Price Details:",
    linemoney: "Line Charge:",
    unit: "USD/Month",
    cloudmoneyall: "Clound Port Charge:",
    nonecloud: "Not Available for the Cloud",
    nonecurmoney: "One-Time Charge:",
    ele: "USD",
    tel:
      "The above prices are for reference only, for more information please call: +86 852-5123-4372",
    relocation: "Reset",
    aftersale: "Submit customer service",
    packnum: "Packet number:",
    packtext: "Number of Packets:",
    loss: "Packet Loss Rate:",
    overtime: "Latency:",
    carry: "Calculate",
    reset: "Reset",
    month: "/Month"
  },
  pricedialog: {
    // 提交成功
    dialogtext: "Submit Successfully!",
    text:
      "We have received your resource request information and will contact you within 48 hours. Have a nice time!",
    config: "Your configuration is as follows：",
    startdeploy: "A-end Configuration：",
    enddeploy: "Z-end Configuration：",
    basisdeploy: "Basic Configuration：",
    refermoney: "Price (USD)：",
    // 其他需求
    require: "Submit your request",
    theme: "Theme of request：",
    contacts: "Contact：",
    phone: "Phone：",
    remarks: "Remarks：",
    radiobtn:
      "We will deal with your request as soon as possible, please wait and keep your phone available!",
    btn: "Send your request",
    // 创建起点-公有云和数据中心
    dialogTextStart: "Create A-end",
    cloudtitle: "Public Cloud",
    datatitle: "IDC",
    cloudtype: "Cloud Types：",
    country: "Country",
    city: "City",
    dataheader: "IDC",
    back: "Previous",
    success: "Submit",
    china: "China",
    // 创建终点-公有云和数据中心
    dialogTextEnd: "Create Z-end"
  },
  map: {
    num1: "30+",
    datacity: "Cities Available",
    num2: "100+",
    datacenter: "IDC",
    num3: "1500+",
    dataport: "Global Data Ports",
    tips: "Tips：",
    tipsone: "All the quotation is based on reachable IDC of TESUCH Global",
    tipstwo:
      "The last mile to IDC and the jumpers in the building are not included in the quotation."
  },
  // 中国地图
  mapworld: {
    data: [
      { name: "Beijing", value: ["116.3979471", "39.9081726"] },

      { name: "Shanghai", value: ["121.4692688", "31.2381763"] },

      { name: "Tianjin", value: ["117.2523808", "39.1038561"] },

      { name: "Chongqing", value: ["106.548425", "29.5549144"] },

      { name: "Hebei", value: ["114.4897766", "38.0451279"] },

      { name: "Shanxi", value: ["112.5223053", "37.8357424"] },

      { name: "Liaoning", value: ["123.4116821", "41.7966156"] },

      { name: "Jilin", value: ["125.3154297", "43.8925629"] },

      { name: "Heilongjiang", value: ["126.6433411", "45.7414932"] },

      { name: "Zhejiang", value: ["120.1592484", "30.265995"] },

      { name: "Fujian", value: ["119.2978134", "26.0785904"] },

      { name: "Shandong", value: ["117.0056", "36.6670723"] },

      { name: "Henan", value: ["113.6500473", "34.7570343"] },

      { name: "Hubei", value: ["114.2919388", "30.5675144"] },

      { name: "Hunan", value: ["112.9812698", "28.2008247"] },

      { name: "Guangdong", value: ["113.2614288", "23.1189117"] },

      { name: "Hainan", value: ["110.3465118", "20.0317936"] },

      { name: "Sichuan", value: ["104.0817566", "30.6610565"] },

      { name: "Guizhou", value: ["106.7113724", "26.5768738"] },

      { name: "Yunnan", value: ["102.704567", "25.0438442"] },

      { name: "Jiangxi", value: ["115.8999176", "28.6759911"] },

      { name: "Shaanxi", value: ["108.949028", "34.2616844"] },

      { name: "Qinghai", value: ["101.7874527", "36.6094475"] },

      { name: "Gansu", value: ["103.7500534", "36.0680389"] },

      { name: "Guangxi", value: ["108.3117676", "22.8065434"] },

      { name: "Xinjiang", value: ["87.6061172", "43.7909393"] },

      { name: "Inner Mongolia", value: ["111.6632996", "40.8209419"] },

      { name: "Tibet", value: ["91.1320496", "29.657589"] },

      { name: "Ningxia", value: ["106.2719421", "38.4680099"] },

      { name: "Taiwan", value: ["120.9581316", "23.8516062"] },

      { name: "HongKong", value: ["114.139452", "22.391577"] },

      { name: "Macao", value: ["113.5678411", "22.167654"] },

      { name: "Anhui", value: ["117.2757034", "31.8632545"] },

      { name: "Jiangsu", value: ["118.7727814", "32.0476151"] },

      { name: "Guangzhou", value: ["113.5107", "23.2196"] },

      { name: "Shijiazhuang", value: ["114.4995", "38.1006"] },

      { name: "Hangzhou", value: ["119.5313", "29.8773"] },

      { name: "Langfang", value: ["116.521", "39.0509"] },

      { name: "Nanjing", value: ["118.8062", "31.9208"] },

      { name: "Wuhan", value: ["114.3896", "30.6628"] },

      { name: "Shenzhen", value: ["114.5435", "22.5439"] },

      { name: "Wuxi", value: ["120.3442", "31.5527"] },

      { name: "Japan", value: ["139.252924", "39.204824"] },

      { name: "Korea", value: ["127.766922", "35.907757"] },

      { name: "France", value: ["2.213749", "45.227638"] },

      { name: "Germany", value: ["14.451526", "48.165691"] },

      { name: "America", value: ["-95.712891", "37.09024"] },

      { name: "Britain", value: ["-2.235973", "56.378051"] },

      { name: "Netherlands", value: ["5.291265999999999", "52.132633"] },

      { name: "Singapore", value: ["101.975766", "4.210484"] }
    ],
    mapdatas: [
      {
        name: "Shanghai",
        value: [121.48, 31.22],
        data: ""
      },
      {
        name: "Guangzhou",
        value: [113.5107, 23.2196],
        data: ""
      },
      {
        name: "Shenzhen",
        value: [114.5435, 22.5439],
        data: ""
      },
      {
        name: "Beijing",
        value: [116.46, 39.92],
        data: ""
      },
      {
        name: "Hangzhou",
        value: [119.5313, 29.8773],
        data: ""
      },
      {
        name: "Shijiazhuang",
        value: [114.4995, 38.1006],
        data: ""
      },
      {
        name: "Wuhan",
        value: [114.3896, 30.6628],
        data: ""
      },
      {
        name: "Langfang",
        value: [116.521, 39.0509],
        data: ""
      },
      {
        name: "Nanjing",
        value: [118.8062, 31.9208],
        data: ""
      }
    ],
    mapdatanew: [
      {
        name: "Shanghai",
        value: [121.48, 31.22],
        data: "Shanghai Xinye"
      },
      {
        name: "Guangzhou",
        value: [113.5107, 23.2196],
        data: "Guangzhou Huaxin Garden"
      },
      {
        name: "Shenzhen",
        value: [114.5435, 22.5439],
        data: "Shenzhen Changhong"
      },
      {
        name: "Beijing",
        value: [116.46, 39.92],
        data: "Beijing Xizhaosi"
      },
      {
        name: "Hangzhou",
        value: [119.5313, 29.8773],
        data: "Hangzhou Dongfang Electronics"
      },
      {
        name: "Shijiazhuang",
        value: [114.4995, 38.1006],
        data: "Shijiazhuang CITIC"
      },
      {
        name: "Wuhan",
        value: [114.3896, 30.6628],
        data: "Wuhan CITIC"
      },
      {
        name: "Langfang",
        value: [116.521, 39.0509],
        data: "Hebei Langfang Hongtaimeishu"
      },
      {
        name: "Nanjing",
        value: [118.8062, 31.9208],
        data: "Nanjing CITIC"
      }
    ]
  },
  geoCoordMap: {
    Shanghai: [121.4648, 31.2891],
    Dongguan: [113.8953, 22.901],
    Dongying: [118.7073, 37.5513],
    Zhongshan: [113.4229, 22.478],
    Linfen: [111.4783, 36.1615],
    Linyi: [118.3118, 35.2936],
    Dandong: [124.541, 40.4242],
    Lishui: [119.5642, 28.1854],
    Urumqi: [87.9236, 43.5883],
    Foshan: [112.8955, 23.1097],
    Baoding: [115.0488, 39.0948],
    Lanzhou: [103.5901, 36.3043],
    Baotou: [110.3467, 41.4899],
    Beijing: [116.4551, 40.2539],
    Beihai: [109.314, 21.6211],
    Nanjing: [118.8062, 31.9208],
    Nanning: [108.479, 23.1152],
    Nanchang: [116.0046, 28.6633],
    Nantong: [121.1023, 32.1625],
    Xiamen: [118.1689, 24.6478],
    Taizhou: [121.1353, 28.6688],
    Hefei: [117.29, 32.0581],
    Hohhot: [111.4124, 40.4901],
    Xianyang: [108.4131, 34.8706],
    Harbin: [127.9688, 45.368],
    Tangshan: [118.4766, 39.6826],
    Jiaxing: [120.9155, 30.6354],
    Datong: [113.7854, 39.8035],
    Dalian: [122.2229, 39.4409],
    Tianjin: [117.4219, 39.4189],
    Taiyuan: [112.3352, 37.9413],
    Weihai: [121.9482, 37.1393],
    Ningbo: [121.5967, 29.6466],
    Baoji: [107.1826, 34.3433],
    Suqian: [118.5535, 33.7775],
    Changzhou: [119.4543, 31.5582],
    Guangzhou: [113.5107, 23.2196],
    Langfang: [116.521, 39.0509],
    Yanan: [109.1052, 36.4252],
    Zhangjiakou: [115.1477, 40.8527],
    Xuzhou: [117.5208, 34.3268],
    Texas: [116.6858, 37.2107],
    Huizhou: [114.6204, 23.1647],
    Chengdu: [103.9526, 30.7617],
    Yangzhou: [119.4653, 32.8162],
    Chengde: [117.5757, 41.4075],
    Lhasa: [91.1865, 30.1465],
    Wuxi: [120.3442, 31.5527],
    Sunshine: [119.2786, 35.5023],
    Kunming: [102.9199, 25.4663],
    Hangzhou: [119.5313, 29.8773],
    Zaozhuang: [117.323, 34.8926],
    Liuzhou: [109.3799, 24.9774],
    Zhuzhou: [113.5327, 27.0319],
    Wuhan: [114.3896, 30.6628],
    Shantou: [117.1692, 23.3405],
    Jiangmen: [112.6318, 22.1484],
    Shenyang: [123.1238, 42.1216],
    Cangzhou: [116.8286, 38.2104],
    Heyuan: [114.917, 23.9722],
    Quanzhou: [118.3228, 25.1147],
    Taian: [117.0264, 36.0516],
    Taizhou: [120.0586, 32.5525],
    Jinan: [117.1582, 36.8701],
    Jining: [116.8286, 35.3375],
    Haikou: [110.3893, 19.8516],
    Zibo: [118.0371, 36.6064],
    Huaian: [118.927, 33.4039],
    Shenzhen: [114.5435, 22.5439],
    Qingyuan: [112.9175, 24.3292],
    Wenzhou: [120.498, 27.8119],
    Weinan: [109.7864, 35.0299],
    Huzhou: [119.8608, 30.7782],
    Xiangtan: [112.5439, 27.7075],
    Binzhou: [117.8174, 37.4963],
    Weifang: [119.0918, 36.524],
    Yantai: [120.7397, 37.5128],
    Yuxi: [101.9312, 23.8898],
    Zhuhai: [113.7305, 22.1155],
    Yancheng: [120.2234, 33.5577],
    Panjin: [121.9482, 41.0449],
    Shijiazhuang: [114.4995, 38.1006],
    Fuzhou: [119.4543, 25.9222],
    Qinhuangdao: [119.2126, 40.0232],
    Shaoxing: [120.564, 29.7565],
    Liaocheng: [115.9167, 36.4032],
    Zhaoqing: [112.1265, 23.5822],
    Zhoushan: [122.2559, 30.2234],
    Suzhou: [120.6519, 31.3989],
    Laiwu: [117.6526, 36.2714],
    Heze: [115.6201, 35.2057],
    Yingkou: [122.4316, 40.4297],
    Huludao: [120.1575, 40.578],
    Hengshui: [115.8838, 37.7161],
    Chuzhou: [118.6853, 28.8666],
    Xining: [101.4038, 36.8207],
    Xian: [109.1162, 34.2004],
    Guiyang: [106.6992, 26.7682],
    Lianyungang: [119.1248, 34.552],
    Xingtai: [114.8071, 37.2821],
    Handan: [114.4775, 36.535],
    Zhengzhou: [113.4668, 34.6234],
    Ordos: [108.9734, 39.2487],
    Chongqing: [107.7539, 30.1904],
    Jinhua: [120.0037, 29.1028],
    Tongchuan: [109.0393, 35.1947],
    Yinchuan: [106.3586, 38.1775],
    Zhenjiang: [119.4763, 31.9702],
    Changchun: [125.8154, 44.2584],
    Changsha: [113.0823, 28.2568],
    Changzhi: [112.8625, 36.4746],
    Yangquan: [113.4778, 38.0951],
    Qingdao: [120.4651, 36.3373],
    Shaoguan: [113.7964, 24.7028],
    Turpan: [89.18596, 42.94244],
    Thatsong: [92.05136, 31.47614],
    LuLiang: [111.15081, 37.51761],
    Yichun: [128.669, 47.72582],
    Hulunbuir: [119.73572, 49.21336],
    Jiayuguan: [98.33435281250001, 39.668377553435185],
    Hanzhong: [107.03194, 33.06784]
  },
  GZData: [
    [
      [
        {
          name: "Beijing",
          value: [116.46, 39.92]
        },
        {
          name: "Shanghai",
          value: [121.48, 31.22]
        }
      ],
      [
        {
          name: "Wuhan",
          value: [114.3896, 30.6628]
        },
        {
          name: "Beijing",
          value: [116.46, 39.92]
        }
      ],
      [
        {
          name: "Shanghai",
          value: [121.48, 31.22]
        },
        {
          name: "Shenzhen",
          value: [114.5435, 22.5439]
        }
      ],
      [
        {
          name: "Shanghai",
          value: [121.48, 31.22]
        },
        {
          name: "Guangzhou",
          value: [113.5107, 23.2196]
        }
      ],
      [
        {
          name: "Shanghai",
          value: [121.48, 31.22]
        },
        {
          name: "Shijiazhuang",
          value: [114.4995, 38.1006]
        }
      ],
      [
        {
          name: "Hangzhou",
          value: [119.5313, 29.8773]
        },
        {
          name: "Shijiazhuang",
          value: [114.4995, 38.1006]
        }
      ],
      [
        {
          name: "Shanghai",
          value: [121.48, 31.22]
        },
        {
          name: "Wuhan",
          value: [114.3896, 30.6628]
        }
      ],
      [
        {
          name: "Shanghai",
          value: [121.48, 31.22]
        },
        {
          name: "Langfang",
          value: [116.521, 39.0509]
        }
      ],
      [
        {
          name: "Shanghai",
          value: [121.48, 31.22]
        },
        {
          name: "Nanjing",
          value: [118.8062, 31.9208]
        }
      ],
      [
        {
          name: "Shanghai",
          value: [121.48, 31.22]
        },
        {
          name: "Hangzhou",
          value: [119.5313, 29.8773]
        }
      ],
      [
        {
          name: "Hangzhou",
          value: [119.5313, 29.8773]
        },
        {
          name: "Guangzhou",
          value: [113.5107, 23.2196]
        }
      ],
      [
        {
          name: "Wuhan",
          value: [114.3896, 30.6628]
        },
        {
          name: "Guangzhou",
          value: [113.5107, 23.2196]
        }
      ],
      [
        {
          name: "Shenzhen",
          value: [114.5435, 22.5439]
        },
        {
          name: "Shijiazhuang",
          value: [114.4995, 38.1006]
        }
      ]
    ]
  ],
  // 世界地图
  mapworlds: {
    data: [
      { name: "Beijing", value: ["116.3979471", "39.9081726"] },

      { name: "Shanghai", value: ["121.4692688", "31.2381763"] },

      { name: "Tianjin", value: ["117.2523808", "39.1038561"] },

      { name: "Chongqing", value: ["106.548425", "29.5549144"] },

      { name: "Hebei", value: ["114.4897766", "38.0451279"] },

      { name: "Shanxi", value: ["112.5223053", "37.8357424"] },

      { name: "Liaoning", value: ["123.4116821", "41.7966156"] },

      { name: "Jilin", value: ["125.3154297", "43.8925629"] },

      { name: "Heilongjiang", value: ["126.6433411", "45.7414932"] },

      { name: "Zhejiang", value: ["120.1592484", "30.265995"] },

      { name: "Fujian", value: ["119.2978134", "26.0785904"] },

      { name: "Shandong", value: ["117.0056", "36.6670723"] },

      { name: "Henan", value: ["113.6500473", "34.7570343"] },

      { name: "Hubei", value: ["114.2919388", "30.5675144"] },

      { name: "Hunan", value: ["112.9812698", "28.2008247"] },

      { name: "Guangdong", value: ["113.2614288", "23.1189117"] },

      { name: "Hainan", value: ["110.3465118", "20.0317936"] },

      { name: "Sichuan", value: ["104.0817566", "30.6610565"] },

      { name: "Guizhou", value: ["106.7113724", "26.5768738"] },

      { name: "Yunnan", value: ["102.704567", "25.0438442"] },

      { name: "Jiangxi", value: ["115.8999176", "28.6759911"] },

      { name: "Shaanxi", value: ["108.949028", "34.2616844"] },

      { name: "Qinghai", value: ["101.7874527", "36.6094475"] },

      { name: "Gansu", value: ["103.7500534", "36.0680389"] },

      { name: "Guangxi", value: ["108.3117676", "22.8065434"] },

      { name: "Xinjiang", value: ["87.6061172", "43.7909393"] },

      { name: "Inner Mongolia", value: ["111.6632996", "40.8209419"] },

      { name: "Tibet", value: ["91.1320496", "29.657589"] },

      { name: "Ningxia", value: ["106.2719421", "38.4680099"] },

      { name: "Taiwan", value: ["120.9581316", "23.8516062"] },

      { name: "HongKong", value: ["114.139452", "22.391577"] },

      { name: "Macao", value: ["113.5678411", "22.167654"] },

      { name: "Anhui", value: ["117.2757034", "31.8632545"] },

      { name: "Jiangsu", value: ["118.7727814", "32.0476151"] },

      { name: "Guangzhou", value: ["113.5107", "23.2196"] },

      { name: "Shijiazhuang", value: ["114.4995", "38.1006"] },

      { name: "Hangzhou", value: ["119.5313", "29.8773"] },

      { name: "Langfang", value: ["116.521", "39.0509"] },

      { name: "Nanjing", value: ["118.8062", "31.9208"] },
      
      { name: "Wuhan", value: ["114.3896", "30.6628"] },
     
      {name: "Shenzhen",value: ["114.5435", "22.5439"]},

      {name: "Wuxi",value: ["120.3442", "31.5527"]},

      {name: "Japan",value: ["139.252924", "39.204824"]},

      {name: "Korea",value: ["127.766922", "35.907757"]},

      {name: "France", value: ["2.213749", "45.227638"]},

      {name: "Germany",value: ["14.451526", "48.165691"]},

      {name: "America",value: ["-95.712891", "37.09024"]},

      {name: "Britain",value: ["-2.235973", "56.378051"]},
      
      {name: "Netherlands",value: ["5.291265999999999", "52.132633"]},
      
      {name: "Singapore",value: ["101.975766", "4.210484"]}
    ],
    mapdatas: [
      {
        name: "HongKong",
        value: [114.139452, 22.391577],
        data: ""
      },
      {
        name: "Japan",
        value: [139.252924, 39.204824],
        data: ""
      },
      {
        name: "Korea",
        value: [127.766922, 35.907757],
        data: ""
      },
      {
        name: "France",
        value: [2.213749, 45.227638],
        data: ""
      },
      {
        name: "Germany",
        value: [14.451526, 48.165691],
        data: ""
      },
      {
        name: "America",
        value: [-95.712891, 37.09024],
        data: ""
      },
      {
        name: "Britain",
        value: [-2.235973, 56.378051],
        data: ""
      },
      {
        name: "Netherlands",
        value: [5.291265999999999, 52.132633],
        data: ""
      },
      {
        name: "Singapore",
        value: [101.975766, 4.210484],
        data: ""
      }
    ],
    mapdatanew: [
      {
        name: "HongKong",
        value: [114.139452, 22.391577],
        data: ""
      },
      {
        name: "Japan",
        value: [139.252924, 39.204824],
        data: ""
      },
      {
        name: "Korea",
        value: [127.766922, 35.907757],
        data: ""
      },
      {
        name: "France",
        value: [2.213749, 45.227638],
        data: ""
      },
      {
        name: "Germany",
        value: [14.451526, 48.165691],
        data: ""
      },
      {
        name: "America",
        value: [-95.712891, 37.09024],
        data: ""
      },
      {
        name: "Britain",
        value: [-2.235973, 56.378051],
        data: ""
      },
      {
        name: "Netherlands",
        value: [5.291265999999999, 52.132633],
        data: ""
      },
      {
        name: "Singapore",
        value: [101.975766, 4.210484],
        data: ""
      }
    ]
  },
  geoCoordMaps: {
    HongKong: [114.139452, 22.391577],
    Japan: [139.252924, 39.204824],
    Korea: [127.766922, 35.907757],
    Germany: [14.451526, 48.165691],
    Netherlands: [5.291265999999999, 52.132633],
    Singapore: [101.975766, 4.210484],
    Britain: [-2.235973, 56.378051],
    America: [-95.712891, 37.09024],
    France: [2.213749, 45.227638],
    Shanghai: [121.4648, 31.2891],
    Dongguan: [113.8953, 22.901],
    Dongying: [118.7073, 37.5513],
    Zhongshan: [113.4229, 22.478],
    Linfen: [111.4783, 36.1615],
    Linyi: [118.3118, 35.2936],
    Dandong: [124.541, 40.4242],
    Lishui: [119.5642, 28.1854],
    Urumqi: [87.9236, 43.5883],
    Foshan: [112.8955, 23.1097],
    Baoding: [115.0488, 39.0948],
    Lanzhou: [103.5901, 36.3043],
    Baotou: [110.3467, 41.4899],
    Beijing: [116.4551, 40.2539],
    Beihai: [109.314, 21.6211],
    Nanjing: [118.8062, 31.9208],
    Nanning: [108.479, 23.1152],
    Nanchang: [116.0046, 28.6633],
    Nantong: [121.1023, 32.1625],
    Xiamen: [118.1689, 24.6478],
    Taizhou: [121.1353, 28.6688],
    Hefei: [117.29, 32.0581],
    Hohhot: [111.4124, 40.4901],
    Xianyang: [108.4131, 34.8706],
    Harbin: [127.9688, 45.368],
    Tangshan: [118.4766, 39.6826],
    Jiaxing: [120.9155, 30.6354],
    Datong: [113.7854, 39.8035],
    Dalian: [122.2229, 39.4409],
    Tianjin: [117.4219, 39.4189],
    Taiyuan: [112.3352, 37.9413],
    Weihai: [121.9482, 37.1393],
    Ningbo: [121.5967, 29.6466],
    Baoji: [107.1826, 34.3433],
    Suqian: [118.5535, 33.7775],
    Changzhou: [119.4543, 31.5582],
    Guangzhou: [113.5107, 23.2196],
    Langfang: [116.521, 39.0509],
    Yanan: [109.1052, 36.4252],
    Zhangjiakou: [115.1477, 40.8527],
    Xuzhou: [117.5208, 34.3268],
    Texas: [116.6858, 37.2107],
    Huizhou: [114.6204, 23.1647],
    Chengdu: [103.9526, 30.7617],
    Yangzhou: [119.4653, 32.8162],
    Chengde: [117.5757, 41.4075],
    Lhasa: [91.1865, 30.1465],
    Wuxi: [120.3442, 31.5527],
    Sunshine: [119.2786, 35.5023],
    Kunming: [102.9199, 25.4663],
    Hangzhou: [119.5313, 29.8773],
    Zaozhuang: [117.323, 34.8926],
    Liuzhou: [109.3799, 24.9774],
    Zhuzhou: [113.5327, 27.0319],
    Wuhan: [114.3896, 30.6628],
    Shantou: [117.1692, 23.3405],
    Jiangmen: [112.6318, 22.1484],
    Shenyang: [123.1238, 42.1216],
    Cangzhou: [116.8286, 38.2104],
    Heyuan: [114.917, 23.9722],
    Quanzhou: [118.3228, 25.1147],
    Taian: [117.0264, 36.0516],
    Taizhou: [120.0586, 32.5525],
    Jinan: [117.1582, 36.8701],
    Jining: [116.8286, 35.3375],
    Haikou: [110.3893, 19.8516],
    Zibo: [118.0371, 36.6064],
    Huaian: [118.927, 33.4039],
    Shenzhen: [114.5435, 22.5439],
    Qingyuan: [112.9175, 24.3292],
    Wenzhou: [120.498, 27.8119],
    Weinan: [109.7864, 35.0299],
    Huzhou: [119.8608, 30.7782],
    Xiangtan: [112.5439, 27.7075],
    Binzhou: [117.8174, 37.4963],
    Weifang: [119.0918, 36.524],
    Yantai: [120.7397, 37.5128],
    Yuxi: [101.9312, 23.8898],
    Zhuhai: [113.7305, 22.1155],
    Yancheng: [120.2234, 33.5577],
    Panjin: [121.9482, 41.0449],
    Shijiazhuang: [114.4995, 38.1006],
    Fuzhou: [119.4543, 25.9222],
    Qinhuangdao: [119.2126, 40.0232],
    Shaoxing: [120.564, 29.7565],
    Liaocheng: [115.9167, 36.4032],
    Zhaoqing: [112.1265, 23.5822],
    Zhoushan: [122.2559, 30.2234],
    Suzhou: [120.6519, 31.3989],
    Laiwu: [117.6526, 36.2714],
    Heze: [115.6201, 35.2057],
    Yingkou: [122.4316, 40.4297],
    Huludao: [120.1575, 40.578],
    Hengshui: [115.8838, 37.7161],
    Chuzhou: [118.6853, 28.8666],
    Xining: [101.4038, 36.8207],
    Xian: [109.1162, 34.2004],
    Guiyang: [106.6992, 26.7682],
    Lianyungang: [119.1248, 34.552],
    Xingtai: [114.8071, 37.2821],
    Handan: [114.4775, 36.535],
    Zhengzhou: [113.4668, 34.6234],
    Ordos: [108.9734, 39.2487],
    Chongqing: [107.7539, 30.1904],
    Jinhua: [120.0037, 29.1028],
    Tongchuan: [109.0393, 35.1947],
    Yinchuan: [106.3586, 38.1775],
    Zhenjiang: [119.4763, 31.9702],
    Changchun: [125.8154, 44.2584],
    Changsha: [113.0823, 28.2568],
    Changzhi: [112.8625, 36.4746],
    Yangquan: [113.4778, 38.0951],
    Qingdao: [120.4651, 36.3373],
    Shaoguan: [113.7964, 24.7028],
    Turpan: [89.18596, 42.94244],
    Thatsong: [92.05136, 31.47614],
    LuLiang: [111.15081, 37.51761],
    Yichun: [128.669, 47.72582],
    Hulunbuir: [119.73572, 49.21336],
    Jiayuguan: [98.33435281250001, 39.668377553435185],
    Hanzhong: [107.03194, 33.06784]
  },
  GZDatas: [
    [
      [
        {
          name: "America",
          value: [-95.712891, 37.09024]
        },
        {
          name: "Netherlands",
          value: [5.291265999999999, 52.132633]
        }
      ],
      [
        {
          name: "HongKong",
          value: [114.139452, 22.391577]
        },
        {
          name: "America",
          value: [-95.712891, 37.09024]
        }
      ],
      [
        {
          name: "Japan",
          value: [139.252924, 39.204824]
        },
        {
          name: "HongKong",
          value: [114.139452, 22.391577]
        }
      ],
      [
        {
          name: "Japan",
          value: [139.252924, 39.204824]
        },
        {
          name: "Korea",
          value: [127.766922, 35.907757]
        }
      ],
      [
        {
          name: "Netherlands",
          value: [5.291265999999999, 52.132633]
        },
        {
          name: "HongKong",
          value: [114.139452, 22.391577]
        }
      ],
      [
        {
          name: "Netherlands",
          value: [5.291265999999999, 52.132633]
        },
        {
          name: "Korea",
          value: [127.766922, 35.907757]
        }
      ],
      [
        {
          name: "Korea",
          value: [127.766922, 35.907757]
        },
        {
          name: "Singapore",
          value: [101.975766, 4.210484]
        }
      ],
      [
        {
          name: "Korea",
          value: [127.766922, 35.907757]
        },
        {
          name: "France",
          value: [2.213749, 45.227638]
        }
      ],
      [
        {
          name: "Britain",
          value: [-2.235973, 56.378051]
        },
        {
          name: "Japan",
          value: [139.252924, 39.204824]
        }
      ],
      [
        {
          name: "Britain",
          value: [-2.235973, 56.378051]
        },
        {
          name: "France",
          value: [2.213749, 45.227638]
        }
      ],
      [
        {
          name: "Singapore",
          value: [101.975766, 4.210484]
        },
        {
          name: "Germany",
          value: [14.451526, 48.165691]
        }
      ],
      [
        {
          name: "France",
          value: [2.213749, 45.227638]
        },
        {
          name: "Singapore",
          value: [101.975766, 4.210484]
        }
      ],
      [
        {
          name: "France",
          value: [2.213749, 45.227638]
        },
        {
          name: "Germany",
          value: [14.451526, 48.165691]
        }
      ],
      [
        {
          name: "Germany",
          value: [14.451526, 48.165691]
        },
        {
          name: "America",
          value: [-95.712891, 37.09024]
        }
      ]
    ]
  ],
  user: {
    // 登录
    accout: "Account login",
    name: "Account name/Email/Mobile number",
    password: "Enter your password",
    checked: "Remember password",
    forgetCode: "Forger password？",
    login: "login",
    regUser: "Haven't signed up yet？",
    signsty: "Sign up for free",
    // 退出登录
    message: "Prompt",
    loginout: "Logout or not？",
    cancel: "Cancel",
    define: "Logout",
    // 注册
    sign: "Welcome to sign up",
    already: "Already have an account？",
    logintap: "Login directly",
    signphone: "Sign up by phone",
    signemail: "sign up by email",
    success: "Sign up successfully, login please",
    backlogin: "Back to login page",
    // 忘记密码
    forgetpassword: "Retrieve password",
    forgetphone: "Phone number retrieval",
    forgetemail: "Mailbox retrieve"
  },
  // 个人资料
  personal: {
    selfcony: "Profile",
    identify: "Enterprise Certification",
    name: "Account：",
    popoverone: [
      {
        name: "① 4-20 characters"
      },
      {
        name: "② numbers, letters and underscores supported"
      },
      {
        name: "③ at least one letter included"
      },
      {
        name: "④ Chinese characters not supported"
      }
    ],
    edit: "Edit",
    save: "Save",
    cancel: "Cancel",
    tapbind: "Click binding",
    albind: "Bound",
    password: "password：",
    phone: "Phone：",
    email: "Email：",
    times: "Registration time：",
    // 修改密码
    textMap: {
      editPwd: "Change password",
      editPho: "Change phone",
      editEma: "Change email",
      bindEma: "Bind email",
      bindPho: "Bind phone"
    },
    oldPwd: "Current password：",
    newPwd: "New password：",
    conPwd: "Confirm new password：",
    success: "Submit",
    // 绑定手机号
    bindphone: "Phone",
    bindcode: "Phone verification code",
    code: "Get verification code",
    bind: "Submit",
    // 修改手机号
    stepData: [
      {
        label: "Verify identity",
        value: 1
      },
      {
        label: "Change phone",
        value: 2
      }
    ],
    editphone: "Send verification code to the phone",
    phonecode: "Phone verification code",
    codefirst: "Get verification code",
    next: "Next",
    newphone: "New phone number",
    newcode: "Phone verification code",
    codephonesecond: "Get verification code",
    cancel: "Cancel",
    submit: "Submit",
    // 绑定邮箱
    bindemail: "Email",
    bindemailcode: "Email verification code",
    codes: "Get verification code",
    // 编辑邮箱
    stepEmail: [
      {
        label: "Verify identity",
        value: 1
      },
      {
        label: "Change email",
        value: 2
      }
    ],
    editemail: "Send verification code to the email",
    emailcode: "Email verification code",
    codesfirst: "Get verification code",
    newemail: "New email:",
    newemailcode: "mail verification code",
    codesecond: "Get verification code"
  },
  selfdata: {
    name: "Company Name：",
    people: "Company Contact：",
    phone: "Contact Phone Number：",
    telphone: "Company Phone Number：",
    address: "Company Address：",
    des: "Remarks：",
    save: "Save",
    num: "No more than 100 words"
  },
  // 注册
  signphone: {
    // 手机号注册
    account: "Account：",
    accountText: "Enter your account please",
    popoverList: [
      {
        name: "① 4-20 characters"
      },
      {
        name: "② numbers, letters and underscores supported"
      },
      {
        name: "③ at least one letter included"
      },
      {
        name: "④ Chinese characters not supported"
      }
    ],
    company: "Company Name：",
    companyText: "Enter your company please",
    company_contact: "Company Contact：",
    company_contact_Text: "Enter your company contact please",
    password: "Password：",
    passwordText: "Set up your password please",
    popoversList: [
      {
        name: "① 6-20 characters"
      },
      {
        name: "② at least two of numbers, letters and underscores included"
      }
    ],
    rePasswords: "Comfirm the password：",
    rePasswordsText: "Enter the password again",
    popoversr: "Ensure the two passwords are identical",
    phone: "Phone：",
    phoneText: "Enter your phone please",
    drag: "Please drag the slider to the right",
    check: "Verify successfully",
    verifyStatus: "Please drag the slider to verify",
    clause: "TESUCH Global Website Terms of Service",
    privacy: "Legal Statement and Privacy Policy",
    care: "Note: those labeled with * are required",
    agree: "Agree with all agreements above and sign up",
    checkphone: "Verify your phone",
    nextText: "Send verification code to your phone",
    phonecode: "Phone verification code：",
    codetext: "Verification code",
    codeStr: "Get verification code",
    submit: "Submit",
    // 邮箱注册
    email: "email：",
    emailText: "Enter your email please",
    checkemail: "Verify your email",
    nextEmail: "Send verification code to your email",
    emailcode: "Email verification code：",
    codeStrs: "Get verification code"
  },
  // 忘记密码
  forgectPhone: {
    phone: "Phone",
    phoneplace: "Enter your phone please",
    drag: "Please drag the slider to the right",
    check: "Verify Successfully",
    verifyStatus: "",
    text: "Please drag the slider to verify：",
    phonecode: "Phone verification code",
    phonetext: "Enter verification code",
    codeStr: "Get verification code",
    passwords: "Enter your password",
    passwordText: "Set up your password please",
    popovers: [
      {
        name: "① 6-20 characters"
      },
      {
        name: "② at least two of numbers, letters and underscores included"
      }
    ],
    rePasswords: "Comfirm the password",
    rePasswordsText: "Enter the password again",
    popoversr: "Ensure the two passwords are identical",
    next: "Next",
    define: "Submit",
    // 下一步弹窗
    nonebind:
      "You haven't bound your phone, please change the verification method.",
    // 修改成功弹窗
    passwordsuccess: "Password retrieved successfully",
    back: "Back to login page"
  },
  forgectEmail: {
    email: "Email",
    emailplace: "Enter your email please",
    drag: "Please drag the slider to the right",
    check: "Verify successfully",
    verifyStatus: "Please drag the slider to verify",
    text: "Send verification code to your email：",
    emailcode: "Email verification code",
    emailtext: "Enter verification code",
    codeStrs: "Get verification code",
    passwords: "Enter your password",
    passwordText: "Set up your password please",
    popovers: [
      {
        name: "① 6-20 characters"
      },
      {
        name: "② at least two of numbers, letters and underscores included"
      }
    ],
    rePasswords: "Confirm the new password",
    rePasswordsText: "Enter the password again",
    popoversr: "Ensure the two passwords are identical",
    next: "Next",
    define: "Submit",
    // 下一步弹窗
    nonebind:
      "You haven't bound your phone, please change the verification method.",
    // 修改成功弹窗
    passwordsuccess: "Password retrieved successfully",
    back: "Back to login page"
  },
  loginout: {
    title: "Prompt",
    out: "Logout or not？",
    cancel: "Cancel",
    bind: "Logout"
  },
  record: {
    keep: "Jingicpb18008832-1",
    permit: "Copyright © 2013-2020 TESUCH Global Global, All Rights Reserved"
  },
  // 校验文字
  checkvalid: {
    password: "Please enter the correct password",
    phone: "Please enter correct mobile number",
    same: "The two passwords are not the same, please re-enter",
    code: "Please enter the verification code",
    hd: "Please drag the slider to the right",
    email: "Please enter the correct email",
    codesuccess: "Verification code sent successfully",
    account: "Please enter the correct account name",
    company: "Please enter company name",
    contact: "Please enter company contact",
    logins: "Login successfully",
    edit: "Modified success",
    oldPwd: "Please enter the correct old password",
    newPwd: "Please enter the correct new password",
    conPwd: "Please enter the new password again",
    bind: "Binding success",
    // 价格
    select: "Please choose",
    pack: "Please enter the number of Ping packages",
    smallthan: "Please enter a value greater than zero and less than 10000",
    packnum: "Please enter the correct number of packages",
    loss: "Trying to read……",
    band: "Please select bandwidth",
    start: "Please create a starting point first",
    end: "Please create the end point first",
    theme: "Please enter requirement subject",
    remarks: "Please input requirements",
    contacts: "Please enter contact name",
    contactsphone: "Please input the mobile number of the contact",
    text: "Please enter text",
    require: "Request sent successfully",
    dialogText: "Cloud starting point",
    selectcity: "Please select a city",
    selectdata: "Please select a data center",
    dc: "DC terminal starting point"
  },
  // 协议
  clause: {
    header: "Tesuch web site service terms",
    time: "December 2019 Edition",
    qy: "Preface",
    list: [
      {
        name: "Welcome to Tesuch web site and use our products and services."
      },
      {
        name:
          "Before completing the registration process or using the service of Tesuch network website in any way, please carefully read and thoroughly understand the terms of service of Tesuch network website (hereinafter referred to as the'terms of service' and choose to accept or not to accept the terms of service after confirming the full understanding. Once you have completed the 'agree terms and register' or started to use the service in other ways, i.e Indicate that you have read and agree to be bound by these terms of service. If you do not agree with the terms of service or any of them, you should not proceed to the next step or stop the registration process."
      },
      {
        name:
          "Tesuch network once again reminds you to carefully read and fully understand the contents of each clause, especially the corresponding clauses of limitation or exemption of liability. The clauses of limitation or exemption of liability will remind you in bold or other eye-catching forms."
      },
      {
        name: "If you are under the age of 18, please read the terms of service with your legal guardian."
      }
    ],
    //  一、
    one: "1、 Contracting parties and scope of agreement",
    oneList: [
      {
        name:
          " 1.1. The terms of service of Tesuch network website is a valid contract between you and Beijing Tesuch Network Co., Ltd. ('Tesuch network' or 'we') for the use of Tesuch network website services (including providing you with website page information browsing, account registration services, etc.)."
      },
      {
        name: "Tesuch web site includes a website with the domain name of http://www.tianchic.com/."
      },
      {
        name:
          "1.2. If you use or purchase a specific service on Tesuch network website, you may still need to confirm the corresponding service terms of the specific service; please carefully read and fully understand the contents of the terms and choose to accept or not to accept the service terms."
      }
    ],
    // 二、
    two: "2、 Account registration, use and security",
    numone: "2.1. Qualification for registration",
    numoneList: [
      {
        name:
          "2.1.1. You confirm that you shall be a natural person, legal person or other organization (hereinafter referred to as 'you') with full capacity for civil rights and full capacity for civil conduct when you complete the registration procedure or actually use the service in other ways permitted by Tesuch network."
      },
      {
        name:
          "2.1.2. If you are a minor or a person with limited capacity for civil conduct, you do not have the above subject qualification, and you and your guardian shall bear all consequences caused by your improper registration."
      },
      {
        name:
          "2.3. Tesuch network hereby reminds you that you shall abide by the laws of the people's Republic of China during the use of Tesuch network services, and shall not endanger the network security, or use the services of Tesuch network to engage in other people's activities infringing reputation, privacy, intellectual property rights and other legitimate rights and interests. Despite the above prompt, Tesuch network will not assume any responsibility for your use and purpose of Tesuch network service."
      },
      {
        name:
          "2.1.3. You also need to ensure that you are not the subject of trade restrictions, sanctions or other legal and rule restrictions imposed by any country, international organization or region, otherwise you may not be able to register and use the Tesuch network service normally."
      }
    ],
    numtwo: "2.2. Account registration",
    numtwoList: [
      {
        name:
          "2.2.1. When you fill in the information, read and agree to the terms of service according to the prompts on the registration page and complete all the registration procedures, you can obtain the account of Tesuch network and become the user of Tesuch network."
      },
      {
        name:
          "2.2.2. The account name ('account name') you set or confirmed at the time of registration and the password you set will become your account (account name and password collectively referred to as 'account') after successful registration."
      },
      {
        name:
          "2.2.3. The account name you set shall not violate national laws and regulations, the management specifications of Tesuch network or easily cause confusion between you and Tesuch network identity, otherwise your account may not be registered successfully or Tesuch network has the right to cancel after notifying you.        "
      },
      {
        name:
          " 2.2.4. You shall provide and update your account information accurately according to the requirements of laws and regulations or the prompts on the corresponding page, so as to make it true, timely, complete and accurate. If the information provided by you is wrong, untrue, outdated or incomplete, Tesuch network can send you a notice of inquiry and / or request for correction, and you should cooperate with Tesuch network to provide or update relevant information according to the requirements of Tesuch network. Because the information and materials you fill in are not true, timely, complete or accurate, you shall bear the consequences and losses of your inability to use Tesuch network account (failure to register successfully, or account is frozen or cancelled) or your use process."
      },
      {
        name:
          "2.2.5. For the opening of some products or services, Tesuch network may require you to provide more identity data and information for further identity authentication or qualification verification. Your account can only obtain the qualification to use relevant products or services after passing these authentication and verification."
      },
      {
        name:
          "2.2.6. Generally, your Tesuch network account is the unique identification of all activities you carry out on Tesuch network website. Unless otherwise agreed, each Tesuch network account can independently carry out activities on this website. However, in the following cases, Tesuch network has the right to handle multiple Tesuch network accounts owned by the same and / or related legal subjects in a unified way according to its own judgment. For example, according to the related information of different Tesuch network accounts in registration, login and use, Tesuch network judges that they are actually the same user. Examples of associated information: the same certificate, the same mobile number, the same payment account, the same device, the same address, etc."
      }
    ],
    numthree: "2.3. Account use and security",
    numthreeList: [
      {
        name:
          " 2.3.1. You have the right to use the account you set to log in to Tesuch network website, and then use other services provided by Tesuch network."
      },
      {
        name:
          "2.3.2. Tesuch network may notify you of the service progress and prompt you to proceed to the next step by email, in station letter, SMS or phone. In the process of service, you should log in to Tesuch network account in time to view and conduct transaction operations."
      },
      {
        name:
          " 2.3.3. A Tesuch network account can only correspond to a unique legal entity. You are not allowed to transfer, gift or let others inherit your account of Tesuch network in any way unless expressly provided by law, judicial ruling or agreed by Tesuch network."
      },
      {
        name:
          " 2.3.4. Your account and password shall be set by you and kept by you. You shall keep your account and password of Tesuch network confidential. You need to make sure you leave the site at the end of each online session with the correct steps."
      },
      {
        name:
          "2.3.5. If you find that other people use your account and password without authorization, you should immediately notify Tesuch network; Tesuch network will help you to freeze your account, change your password or make other security settings; you understand that Tesuch network needs a reasonable time to take action on your request, and Tesuch network's consequences (including but not limited to Not limited to any loss of you) without any liability."
      },
      {
        name:
          "2.3.6. Tesuch network will also take reasonable technical measures at the service end of the website to ensure the security of the account."
      }
    ],
    // 三、
    three: "3、 Freezing, cancellation and appeal of accounts",
    three_one: "3.1. Account freezing",
    three_one_list: [
      {
        name:
          "Your Tesuch network account (full or partial permissions or functions) may be frozen in the following circumstances (such as restricted fund transfer out function of Tesuch network account), and Tesuch network will notify you by email, in station letter, SMS or phone, etc.:"
      },
      {
        name:
          " 3.1.1. Based on the needs of Tesuch network website or service operation and transaction security, if you have or may have sabotaged or attempted to sabotage the fair trading environment or normal trading order of Tesuch network or Tesuch network affiliates, or any use containing the name and brand of Tesuch network or Tesuch network affiliates and misleading suspicion to others or any use of a certain Chinese and English (full name or Abbreviation), number, domain name, etc. are intended to indicate or map a certain association with Tesuch network or its affiliates;"
      },
      {
        name:
          "3.1.2. Violating the terms of service, relevant rules, specifications (such as transaction rules and management specifications), service description and other service agreements / terms of Tesuch network website;"
      },
      {
        name: "3.1.3. Violating the provisions of national laws, regulations, policies and legal documents;"
      },
      {
        name:
          " 3.1.4. You have been complained by others, and the other party has provided relevant evidence, but you have not provided the opposite evidence according to our requirements;"
      },
      {
        name:
          "3.1.5. Tesuch network judges that your account operation, income and exchange are abnormal according to reasonable analysis;"
      },
      {
        name: "3.1.6. Freezing required by the state authorities;"
      },
      {
        name:
          "3.1.7. According to reasonable judgment of Tesuch network, you have other situations of the same nature as the above behaviors or similar risks."
      }
    ],
    three_two: "3.2. Cancellation of account",
    three_two_list: [
      {
        name:
          "3.2.1. In case of any serious situation as mentioned in Article 3.1 above, or based on the requirements of the competent authorities of the state, your Tesuch network account (full or partial authority or function) will be cancelled, and Tesuch network will notify you by email, in station letter, SMS or phone."
      },
      {
        name:
          "3.2.2. You understand and agree that if you fail to log in to Tesuch network website through your account for 12 consecutive months, and there is no unexpired service under your account, Tesuch network has the right to cancel your account, and you will no longer be able to log in to Tesuch network website."
      }
    ],
    three_three: "3.3. appeal",
    three_three_list: [
      {
        name:
          "In case of freezing or cancellation of the aforesaid account, you should pay attention to it in a timely manner, and you can appeal and other follow-up operations in accordance with the procedure:"
      },
      {
        name:
          " 3.3.1. If you apply to Tianchi network for lifting the above freezing or cancellation through the appeal procedure, for the sake of your account security, you should cooperate with Tianchi network to truthfully provide the identity certificate and relevant information, as well as other information or documents required by Tianchi network, so that Tianchi network can verify them. You should fully understand that your appeal is not necessarily allowed, and Tianchi network has the right to decide whether to agree to your appeal."
      },
      {
        name:
          "3.3.2. You understand and agree that if you refuse to provide the identity certificate and relevant information truthfully, or fail to pass the audit of Tianchi network, Tianchi network has the right to freeze such accounts for a long time and restrict some or all functions of the accounts for a long time."
      }
    ],
    // 四
    four: "4、 Website services and specifications",
    four_one:
      "4.1. You have the right to enjoy the Internet technical services and information services provided by Tesuch network through this website. At the same time, you shall also fulfill the responsibilities of timely payment, service management, etc. according to the terms of service and the relevant terms and conditions confirmed when you purchase specific services.",
    four_two: "4.2. If you use the services of Tesuch network, you shall guarantee:",
    four_one_text:
      " 4.2.1. When you use Tesuch network services, you will comply with national and local laws and regulations, industry practices and social public ethics, and will not use the services provided by Tesuch network to store, publish and disseminate the following information and content:",
    four_one_list: [
      {
        name: "（ⅰ）Any content (information) in violation of national laws, regulations and policies;"
      },
      {
        name: "（ⅱ）Political propaganda and / or news information in violation of state regulations;"
      },
      {
        name: "（ⅲ）Information concerning state secrets and / or security;"
      },
      {
        name: "（ⅳ）Feudal superstition and / or obscene, pornographic, obscene information or information abetting crime;"
      },
      {
        name: "（ⅴ）Gambling with prizes and gambling games; information violating national ethnic and religious policies;"
      },
      {
        name: "（ⅵ）Information hindering the security of Internet operation;"
      },
      {
        name:
          "（ⅶ）Information that infringes upon the legitimate rights and interests of others and / or other information or content that is harmful to social order, public order and public morality;"
      },
      {
        name:
          "（ⅷ）At the same time, you promise not to provide any convenience for others to publish the information content that does not conform to the national regulations and / or the terms of service, including but not limited to setting URL, banner link, etc;"
      }
    ],
    four_one_text: [
      {
        name:
          "4.2.2. There shall be no acts of sabotage or attempt to sabotage the network security, including not using technology or other means to sabotage or disturb the website of this website and other customers of Tesuch network;"
      },
      {
        name:
          " 4.2.3. Your use of the service of Tesuch network website shall comply with the terms of service; if you violate the above guarantee, Tesuch network has the right to delete information, suspend service and terminate service according to the relevant terms of service, and has the right to freeze or cancel some or all functions of your account."
      }
    ],
    // 五、
    five: "5、 Privacy and protection of personal information",
    five_list: [
      {
        name:
          "Your trust is very important to Tesuch network. Tesuch network knows the importance of user information security. Tesuch network will take security protection measures according to laws and regulations to protect your user information security and controllability. For details, please refer to the legal statement and privacy policy."
      }
    ],
    // 六、
    six: "6、 Intellectual property",
    six_list: [
      {
        name:
          "6.1. We respect the intellectual property rights. Except with your consent, Tesuch network will not use, modify, copy, publicly disseminate, change, distribute, distribute or publicly publish the results of your intellectual property rights without authorization."
      },
      {
        name:
          "6.2. Any organization or individual who believes that the web page content of Tesuch network website, such as reprinted articles, commodity information published by cloud market service providers, may infringe their legitimate rights and interests, may submit a written notice of rights to Tesuch network (http://www.tianchic.com/), and Tesuch network will handle it as soon as possible after receiving the qualified notice from the intellectual property right owner."
      },
      {
        name:
          "6.3. Unless otherwise specified, the intellectual property rights of the logo, Tesuch network, aliyun and other words, graphics and their combinations, as well as other logos, emblems, names of Tesuch network services and technical documents of Tesuch network are owned by Tesuch network and its related companies."
      },
      {
        name:
          " 6.4. You shall respect the intellectual property rights and other legal rights / interests of Tesuch network and the third party, and guarantee to protect Tesuch network and its employees, shareholders, partners, etc. from being affected or lost in case of any illegal event infringing the aforesaid rights and interests. Tesuch network reserves the right to terminate the provision to you when you infringe the legal rights / interests of Tesuch network and / or other third parties The service does not have the right to refund any money."
      },
      {
        name: "For other specific information, please refer to the legal statement of the legal statement and privacy policy."
      }
    ],
    seven: "7、confidentiality",
    seven_list: [
      {
        name:
          "Tesuch network promises to take confidentiality measures for the information submitted or known by you when you register your account or use Tesuch network service, and will not disclose your information to a third party unless:"
      },
      {
        name:
          "7.1.According to the terms of service or other service agreements, contracts, online terms and other provisions between you and Tianchi network;"
      },
      {
        name: "7.2. According to the provisions of laws and regulations or the requirements of administrative and judicial authorities;"
      },
      {
        name:
          "7.3. The confidential information has been or can be obtained from the public domain on the premise of not violating the liability stipulated in the terms of service."
      }
    ],
    eight: "8、 Export control",
    eight_list: [
      {
        name:
          " Both parties undertake to abide by the applicable laws and regulations of the United Nations, China, the United States and other countries on export control. You promise not to use the products or services provided by Tesuch network for the purposes prohibited by applicable export control laws and regulations. You and other individuals or entities authorized by you to use Tesuch network products or services will not provide controlled technology, software or services to entities or individuals prohibited by applicable export control laws and regulations through Tesuch network products or services without permission of relevant competent authorities."
      }
    ],
    nine: "9、 Information security incidents",
    nine_list: [
      {
        name:
          " Tesuch network manages information security incidents in accordance with the requirements of national laws and regulations and relevant security incident handling standards. When there is an information security incident involving your relevant assets, we will timely inform you of the relevant information of the incident by mail, letter, phone, push notice and other means according to law. You can also actively contact us by work order, customer service phone, key account manager phone and other means."
      }
    ],
    ten: "10、 Scope and limitation of liability",
    ten_list: [
      {
        name:
          "10.1. You understand and agree that you shall be liable for any third party claims arising from your use of the service, breach of the terms of service or any action taken under your account. If Tesuch network and its affiliates, employees, customers and partners are claimed by a third party, you shall be responsible for handling and compensating Tesuch network and its affiliates for all losses and liabilities incurred."
      },
      {
        name:
          "10.2. To the extent permitted by applicable law, Tesuch network shall not be liable for any indirect, punitive, special and derivative losses related to or caused by the terms of service."
      },
      {
        name:
          "10.3. Tesuch network hereby reminds you that you shall abide by the laws of the people's Republic of China during the use of Tesuch network services, and shall not endanger network security, or use the services of Tesuch network to engage in activities that infringe upon the reputation, privacy, intellectual property rights and other legitimate rights and interests of others. Tesuch network shall not be liable for any illegal or breach of contract of your use of Tesuch network services."
      },
      {
        name:
          " 10.4. Users of Tesuch network upload, provide and publish relevant information on the forum, community and cloud market of Tesuch network website by themselves, including but not limited to user name, company name, contact person and contact information, relevant pictures and information, etc., which shall be provided by users themselves. Users of Tesuch network shall bear full responsibility for the aforesaid information provided by them according to law."
      },
      {
        name:
          "10.5. If you use the Tesuch network website or obtain any products or services from a third party, for example, the service provider in the cloud market of Tesuch network provides services to you relying on the cloud market, the service provider will be responsible for the services it provides to you, and Tesuch network will not take any responsibility for the third party services."
      },
      {
        name:
          "10.6. In some cases, in order to help you use the services of Tesuch network more conveniently, Tesuch network may display the reference code or software of Tesuch network (if it belongs to the third-party open-source software, you should comply with the relevant use requirements of the third-party open-source software). Based on the use instructions of the corresponding display page, the software may allow you to download, carry out secondary development, etc For operation, you should understand and promise that the intellectual property right of the code belongs to Tesuch network, and you should clearly indicate the obligee when you use it. At the same time, Tesuch network is not responsible for whether you can use and the work and consequences of using the code and software."
      }
    ],
    eleven: "11、 Force majeure and accidents",
    eleven_list: [
      {
        name:
          "Tesuch network shall not be liable for damages if its website may not operate normally due to the following force majeure or unexpected events:"
      },
      {
        name:
          "11.1. Due to natural disasters, strikes, riots, wars, government actions, judicial and administrative orders and other force majeure factors;"
      },
      {
        name: "11.2. Public service factors such as power supply failure and communication network failure;"
      },
      {
        name: "11.3. System maintenance of Tesuch network in a short period of time after advance announcement or notice."
      }
    ],
    twelve: "12、 Application and jurisdiction of law",
    twelve_list: [
      {
        name:
          "The validity, interpretation, change, execution and dispute resolution of these terms of service shall be governed by the laws of the people's Republic of China. Any dispute arising from these terms of service shall be submitted to Beijing Arbitration Commission for arbitration."
      }
    ],
    thirteen: "13、 Service of notice",
    thirteen_list: [
      {
        name:
          " 13.1. You understand and agree that Tesuch network can send you a notice through one or more of the above notification methods, such as web announcement, email, in station letter, SMS, phone, system message and instant messaging, and Tesuch network can trust that the contact information provided by you is complete, accurate and currently effective; the above notice shall be deemed to have been delivered after sending successfully."
      },
      {
        name:
          "13.2．Unless otherwise agreed in the terms of service or otherwise specified in the agreement signed between Tesuch network and you, the notice you send to Tesuch network shall be delivered through the contact information officially published by Tesuch network, such as communication address, fax number, email address, etc."
      }
    ],
    fourteen: "14、 Renewal and termination of terms",
    fourteen_list: [
      {
        name:
          "14.1. Tesuch network has the right to make changes to the terms of service and the corresponding service rules, and make announcements or notices by means of webpage announcement, email, in station letter, SMS, etc.; if you continue to use the service after the change of the terms of service, it means that you have fully read, understood and accepted the modified content, and will also follow the modified terms."
      },
      {
        name:
          "14.2. If your account is cancelled or the website service is terminated by mutual agreement, the terms of service will be terminated."
      }
    ],
    fifteen: "15、 Others",
    fifteen_list: [
      {
        name:
          "15.1. The terms of service are composed of the contents of the terms of service, the rules and specifications displayed on the relevant pages of the website, the service description (including the operation documents) and other terms / conditions you click to confirm. Tesuch network and you are bound by them, and the relevant terms can be quoted and interpreted mutually."
      },
      {
        name:
          "15.2. The section headings of these terms of service are for convenience only and have no legal or contractual effect."
      },
      {
        name:
          " 15.3. Any provision of these terms of service shall be deemed to be invalid, invalid or unenforceable. Such provision shall be deemed to be separable and shall not affect the validity and enforceability of these terms of service and other provisions."
      },
      {
        name:
          "15.4. Tesuch network has the right to publish an announcement, send in station notice or email notice on the official website of Tesuch network (http://www.tianchic.com/) and transfer all or part of the rights and obligations of this service to the affiliated companies of Tesuch network."
      },
      {
        name:
          "15.5. Unless otherwise agreed, for the sake of service professionalism, Tesuch network may also entrust affiliated companies or other legal entities to provide you with one or more specific services on the website of Tesuch network. At the same time, you may enter into relevant terms or conditions with such companies. Please carefully read and fully understand the terms and conditions and choose to accept or not to accept them."
      },
      {
        name:
          "15.6. The confidentiality clause, intellectual property clause, law application and jurisdiction clause and other clauses (such as the authenticity guarantee of registered information, etc.) under the terms of service shall not be invalid due to the termination of this clause."
      }
    ]
  },
  privacy: {
    header: "Legal statement and privacy policy",
    time: "Latest updated: November 23, 2019",
    times: "Effective date: November 30, 2019",
    ts: "Hint clause",
    list: [
      {
        name:
          "Your trust is very important to us. We are fully aware of the importance of user information security. We will take security protection measures to protect your user information security in accordance with the requirements of laws and regulations. In view of this, Tesuch network (or 'we') formulates this legal statement and privacy policy (hereinafter referred to as 'statement and policy') and reminds you that before using the services of Tesuch network website, you must carefully read and thoroughly understand this legal statement and privacy policy, and use the relevant products and services after full understanding and consent. Once you start using the Tesuch network service, it will be deemed as the acceptance and recognition of the content of this statement and policy."
      },
      {
        name:
          "If you have any questions, opinions or suggestions about the contents of this statement and policy, you can contact us through the work order and suggestion submission platform of Tesuch network."
      }
    ],
    content: "Definition",
    contentList: [
      {
        name:
          "Tesuch network website: refers to Tesuch network official website (Domain Name: http://www.tianchic.com/). Tesuch network website: refers to Tesuch network official website (Domain Name: http://www.tianchic.com/)."
      },
      {
        name:
          "Tesuch network: unless otherwise agreed, Beijing Tesuch Network Co., Ltd. is the operator of http://www.tianchic.com/ and Tesuch network client."
      },
      {
        name:
          "User information: user information refers to the user member information, such as name, contact information, etc. submitted by you or collected by Tesuch network in order to provide services to you by registering the account of Tesuch network website, using the services of Tesuch network, and for details, please refer to the information described in Article 2 of the privacy policy."
      },
      {
        name:
          "Business data: different from user information, it refers to the data that users of Tesuch network upload, download and distribute through technical services of Tesuch network."
      }
    ],
    sm: "Legal statement",
    //  一、
    one: "1、 Ownership of rights",
    oneList: [
      {
        name:
          " 1.1. The logo of Tesuch network website, 'Tesuch network', 'tesuch' and other words, graphics and their combinations, as well as other logos, emblems and service names of Tesuch network website are registered trademarks of Tesuch network and its related companies in China and other countries. Without written authorization of Tesuch network, no one is allowed to display, use or do other processing in any way (including but not limited to copying, spreading, displaying, mirroring, uploading and downloading), or show others that you have the right to display, use or do other processing."
      },
      {
        name:
          " 1.2. Intellectual property rights of all products, services, technologies and procedures (hereinafter referred to as 'technical services') of Tesuch network website belong to Tesuch network or its obligee."
      }
    ],
    // 二、
    two: "2、 Limitation of liability",
    numoneList: [
      {
        name:
          "2.1. Users of Tesuch network upload, provide and publish relevant information, including but not limited to user name, company name, contact person and contact information, relevant pictures and information, etc. on the forum, community and cloud market of Tesuch network website by themselves. Such information shall be provided by users by themselves. Users of Tesuch network shall bear full responsibility for any information provided by them according to law."
      },
      {
        name:
          " 2.2. Tesuch network hereby reminds you that you shall abide by the laws of the people's Republic of China during the use of Tesuch network services, and shall not endanger the network security, or use the services of Tesuch network to engage in other people's activities infringing reputation, privacy, intellectual property rights and other legitimate rights and interests. Despite the above prompt, Tesuch network will not assume any responsibility for your use and purpose of Tesuch network service."
      }
    ],
    // 三、
    three: "3、 Intellectual property protection",
    three_one:
      "We respect intellectual property rights and oppose and combat violations of intellectual property rights. If any organization or individual believes that the content of the webpage (including the content of www.xxxxx.com webpage and the client page) of Tesuch network website (such as reprinted articles, commodity information published by cloud market service providers, etc.) may infringe their legitimate rights and interests, they can send a written notice of rights to Tesuch network, and Tesuch network will handle it as soon as possible after receiving the qualified notice from the intellectual property right owner.",
    hide: "Privacy policy",
    numthreeList: [
      {
        name:
          " Tesuch network (hereinafter referred to as 'we') respects and protects user information and will treat such information with a high degree of diligence and prudence. We will collect, process and disclose your information in accordance with this privacy policy when you use the services provided by Tesuch network website. We hope to give you a clear introduction of how we deal with your information through this privacy policy. Therefore, we suggest that you read this privacy policy completely to help you understand how to protect your privacy. If you have any questions, comments or suggestions, please contact us through various contact information provided by Tesuch network. This policy will help you understand the following:"
      },
      {
        name: "1、 Scope of this Agreement"
      },
      {
        name: "2、 How we collect and use your user information"
      },
      {
        name: "3、 How do we share, transfer and publicly disclose your user information"
      },
      {
        name: "4、 User business data and public information"
      },
      {
        name: "5、 How do you manage your user information"
      },
      {
        name: "6、 How do we protect and save your user information"
      },
      {
        name: "7、 Special agreement on minor user information"
      },
      {
        name: "8、 Update of privacy policy"
      },
      {
        name: "9、 How to contact us"
      }
    ],
    numberone: "1、 Scope of this Agreement",
    numberlist: [
      {
        name:
          "1.1. This privacy policy is applicable to all services of Tesuch Internet site. Services include page browsing, website login and technical services provided to you through Tesuch network website."
      },
      {
        name:
          "1.2. This privacy policy does not apply to services provided to you by other third parties. For example, when a service provider in Tesuch network cloud market provides services to you based on the cloud market, the information you provide to the service provider does not apply to this privacy policy."
      },
      {
        name:
          "1.3. It should be specially noted that as a user of Tesuch network, if you use the technical services of Tesuch network to provide services for your users, since your business data belongs to you, you should separately agree on the privacy policy with your users."
      }
    ],
    numbertwo: "2、 How we collect and use your user information",
    number_one: "（1） How we collect your user information",
    number_onelist: [
      {
        name: "2.1. Help you become our member"
      },
      {
        name:
          "2.1.1. When you create an account on Tesuch network website, you must provide us with the member name, set and confirm your login password, and provide your mobile number in the people's Republic of China. The mobile phone number you submit is used to accept the verification code when you register, log in, bind your account, and retrieve your password. It is also used as one of the contact ways specified by you and Tesuch network to receive relevant business notices (such as new product launch, service change, etc.)."
      },
      {
        name:
          " 2.1.2. After you register for Tesuch network account, you can continue to fill in your information in the 'basic information' column of the account, including (1) your account name, company name, etc."
      },
      {
        name:
          " 2.1.3. After you sign up for Tesuch network account, you need to submit the contact information in the account management console, including your designated contact's email address, mobile number and contact's position. Tesuch network will promote and introduce products, send business notices (including bills) or communicate with you through the above information."
      },
      {
        name:
          "  2.1.4.If you only need to use the basic services such as browsing and searching of Tesuch web site, you do not need to register as our member and provide the above information."
      },
      {
        name: "2.2.Provide you with technical services"
      },
      {
        name:
          "2.2.1.According to the law of the people's Republic of China, when you use specific technical services, you should provide your real identity information through your account."
      },
    ],
    number_two: "（2） How we use your user information",
    number_twolist: [
      {
        name: "2.2. We use the user information submitted by you and collected by us for the following purposes:"
      },
      {
        name:
          "2.2.1. In order to provide services to you, we will send you information, notices or business communication with you, including but not limited to the verification code necessary to ensure the completion of the service, and push notices necessary to use the service;"
      },
      {
        name:
          "2.2.2. In order to maintain and improve the service and provide you with more personalized information display, we may combine the user information from one service of Tesuch network website with the information from other services, make feature models and user portraits, display and push information and possible commercial advertisements to you, including but not limited to news about Tesuch network products As well as marketing activities and promotional information, promotion information of the third party of Tesuch network cooperation, or other content that you may be interested in. If you do not want to receive the commercial electronic information sent to you by us, you can unsubscribe by SMS prompt reply or according to the unsubscribe method provided in the information;"
      },
      {
        name:
          "2.2.3. We may design, develop and promote brand-new products and services based on user information statistics; we will make statistics on the use of our services and may share these statistics with the public or a third party, but these statistics do not include any identification information of you;"
      },
      {
        name:
          "2.2.4. In order to improve the security of your use of services provided by us, our affiliates and partners, ensure the security of the operating environment and identify the abnormal status of your account, protect your or other users or the public's personal and property security from infringement, better prevent phishing websites, fraud, network vulnerabilities, computer viruses, network attacks, network intrusion and other security risks, and more accurately identify violations In case of anti laws and regulations or relevant agreements and rules of Tesuch network, we may use your member information, and integrate equipment information, relevant network logs and information legally shared by our affiliated companies and partners to judge your account and transaction risks, conduct identity verification, detect and prevent security incidents, and take necessary records, audits, analysis Disposal measures;"
      },
      {
        name:
          "2.2.5. If we use the user information beyond the stated purpose of collecting the user information, or beyond the scope of direct or reasonable association, we will inform you again and ask your express consent."
      }
    ],
    numberthree: "3、 How do we share, transfer and publicly disclose your user information",
    number_three: "3.1. sharing",
    number_threelist: [
      {
        name: "We will not share your user information with other organizations and individuals, except:"
      },
      {
        name:
          "3.1.1.Sharing with explicit consent: after obtaining your explicit consent, we will share your user information with other parties;"
      },
      {
        name:
          "3.1.2.Sharing under legal circumstances: we may share your user information externally according to laws and regulations, litigation and arbitration settlement needs, or according to the requirements of administrative and judicial authorities according to law;"
      },
      {
        name:
          "3.1.3.In order to facilitate the transaction or assist in dispute resolution, in some cases, only sharing your user information can facilitate the transaction or deal with disputes or disputes between you and others. For example, in a transaction created on the cloud market of Tesuch network, if any party to the transaction fulfills or partially fulfills its transaction obligations and requests for information disclosure, Tesuch network has the right to decide to provide the user with its own information Necessary information such as contact information of the counterparty to facilitate the completion of the transaction;"
      },
      {
        name:
          "3.1.4.Share with authorized partners: we may entrust trusted partners to provide services, so we may share some of your user information with partners to provide better customer service and optimize the user experience. We will only share your user information for legal, legitimate, necessary, specific and clear purposes, and only share the user information necessary to provide services. Our partners do not have the right to use the shared user information for any other purpose. At present, our authorized partners include the following types: suppliers, service providers and other partners. We send information to suppliers, service providers and other partners who support our business, including providing basic technical services, consulting, analysis and other professional services. For the companies, organizations and individuals with whom we share user information, we will sign strict confidentiality agreement and information protection agreement with them, and require them to process user information in accordance with our instructions, this Privacy Policy and any other relevant confidentiality and security measures."
      }
    ],
    three_two: "3.2. Transfer the possession of",
    three_two_list: [
      {
        name:
          "We will not transfer your user information to any company, organization or individual except:"
      },
      {
        name:
          "3.2.1. Transfer with explicit consent: after obtaining your explicit consent, we will transfer your user information to other parties;"
      },
      {
        name:
          "3.2.2. In case of merger, acquisition or bankruptcy liquidation between Tesuch network and other legal subjects, or other situations involving merger, acquisition or bankruptcy liquidation, if user information transfer is involved, we will require new companies and organizations holding your user information to continue to be bound by this policy, otherwise we will require the companies, organizations and individuals to ask you for authorization and consent again."
      }
    ],
    three_three: "3.3.Public disclosure",
    three_three_list: [
      {
        name: "We will only publicly disclose your user information if:"
      },
      {
        name:
          " 3.3.1.With your explicit consent or based on your active choice, we may disclose your user information publicly;"
      },
      {
        name:
          "3.3.2.Or in order to protect the personal and property safety of users or the public of Tesuch network platform and its affiliated companies, we may disclose information about your users in accordance with applicable laws or relevant agreements and rules of Tesuch network platform. For example, if you sell fake or pirated goods as a cloud market service provider, we may publicly disclose the main information and penalties of your store."
      }
    ],
    three_four: "3.4.Exceptions of prior authorization consent in case of sharing, transferring and public disclosure of user information",
    three_four_list: [
      {
        name:
          "In the following cases, the sharing, transfer and public disclosure of your user information do not require your prior authorization and consent:"
      },
      {
        name: "3.4.1. Related to national security and national defense security;"
      },
      {
        name: "3.4.2. Related to public safety, public health and major public interests;"
      },
      {
        name: "3.4.3. Related to criminal investigation, prosecution, trial and execution of judgment, etc;"
      },
      {
        name:
          "3.4.4. In order to protect your or other personal life, property and other major legitimate rights and interests, but it is difficult to obtain my consent;"
      },
      {
        name: "3.4.5. Your personal information disclosed to the public by yourself;"
      },
      {
        name:
          " 3.4.6. Collecting personal information from legally disclosed information, such as legal news reports, government information disclosure and other channels."
      }
    ],
    // 四
    four: "4、 User business data and public information",
    fourtext:
      "Different from your user information, for user business data and public information, Tesuch network will process as follows:",
    four_one: "4.1. User business data",
    four_one_list: [
      {
        name:
          "4.1.1. The services you provide through Tesuch network, data processed, stored, uploaded, downloaded, distributed and processed by other means are all your user business data, and you have your user business data completely. As a cloud service provider, Tesuch network will only process your business data in strict accordance with your instructions, and will not make any unauthorized use or disclosure of your business data except as agreed with you or in accordance with clear laws and regulations."
      },
      {
        name:
          "4.1.2. You shall be responsible for the source and content of your user's business data, and Tesuch network prompts you to judge the legitimacy of the source and content carefully. All results and responsibilities caused by your user's business data content violating laws and regulations, departmental rules or national policies shall be borne by you."
      },
      {
        name:
          "4.1.3. According to the consensus between you and Tesuch network, Tesuch network stores user business data in your selected data center. Tesuch network adheres to the security commitment to users and protects the data stored in the data center of Tesuch network in accordance with applicable laws."
      }
    ],
    four_one_text: [
      {
        name:
          "4.2.2. There shall be no acts of sabotage or attempt to sabotage the network security, including not using technology or other means to sabotage or disturb the website of this website and other customers of Tesuch network;"
      },
      {
        name:
          " 4.2.3. The service you use on Tesuch network website shall comply with the terms of service. If you violate the above guarantee, Tesuch network has the right to take measures to delete information, suspend service and terminate service according to the relevant terms of service, and has the right to freeze or cancel part or all of your account functions."
      }
    ],
    four_two: "4.2. Public information",
    four_two_list: [
      {
        name:
          "4.2.1. Public information refers to any information you publicly share, which can be viewed or accessed by anyone during the use and non use of Tesuch web site service. For example, the information you published in Tesuch Web Developer Forum."
      },
      {
        name:
          "4.2.2. In order to use Tesuch network website service, there may be information that you must share publicly. For example, in order to build a credit trading environment in the cloud market, your credit evaluation information (star rating, customer evaluation) needs to be publicly shared. If you are a service provider (seller), you should publicly share the relevant information of the enterprise or natural person operator according to the requirements of applicable laws and regulations and the rules of Tesuch online cloud market."
      },
      {
        name:
          "4.2.3. When you use the cloud market of Tesuch network website for transaction, you inevitably need to disclose your personal information, such as contact information or postal address, to the counterparty or potential counterparty. Please protect your personal information and provide it to others only when necessary. You can also connect and share with each other through our services. When you create communication, transaction or sharing through our services, you can choose the object of communication, transaction or sharing independently as the third party who can see your contact information, exchange information or share content and other relevant information. If you find that your personal information is leaked, especially your account or password, please contact customer service of Tesuch network immediately so that Tesuch network can take corresponding measures."
      }
    ],
    // 五、
    five: "5、 How do you manage your user information",
    five_list: [
      {
        name:
          "5.1. You can log into Tesuch network website or client 'management console'to query, manage (change, delete) the basic business information (basic information) and contact information submitted when using Tesuch network service."
      },
      {
        name:
          "5.2. If you need to change the information of your Tesuch network account, you need to log in to the Tesuch network website to modify the information."
      },
      {
        name: "5.3. In the following cases, you can ask us to delete user information:"
      },
      {
        name: "5.3.1. If our handling of user information violates laws and regulations;"
      },
      {
        name: "5.3.3. If our handling of personal information seriously violates the agreement with you."
      },
      {
        name:
          "5.4 each business function requires some basic user information to be completed (see article 2 of this Privacy Policy). In addition, you can give or withdraw your authorization consent in contact with Tesuch network customer service. When you withdraw your consent, we will not process the corresponding user information. However, your decision to withdraw your consent will not affect the user information processing based on your authorization."
      },
    ],
    seven: "6、How do we protect and save your user information",
    seven_list: [
      {
        name:
          "6.1. Tesuch network attaches great importance to your information security. We strive to take all reasonable physical, electronic and administrative security measures to protect your user information. Prevent unauthorized access, public disclosure, use, modification, damage or loss of user information. We will use encryption technology to improve the security of user information; we will use trusted protection mechanisms to prevent malicious attacks on user information; we will deploy access control mechanisms to try to ensure that only authorized personnel can access user information; and we will hold security and privacy protection training courses to enhance employees' awareness of the importance of protecting user information."
      },
      {
        name:
          " 6.2. We will take reasonable and feasible measures to avoid collecting irrelevant user information. We will only keep your user information for the period required to achieve the purpose stated in the cost policy, unless permitted by law. Beyond the retention period of the above user information, we will delete or anonymize your personal information."
      },
      {
        name:
          "6.3. Please use complex password to help us ensure the security of your account. We will do our best to ensure the security of any information you send us. If our physical, technical or management protection facilities are damaged, resulting in unauthorized access, public disclosure, tampering or destruction of information, resulting in damage to your legitimate rights and interests, we will bear the corresponding legal responsibility."
      },
      {
        name:
          "6.4. In case of user information security incidents (leakage, loss, etc.), we will inform you in time of the basic situation and possible impact of the security incident, the measures we have taken or will take, the suggestions you can take to prevent and reduce the risk independently, and the remedial measures for you in accordance with the requirements of laws and regulations. We will inform you of the event in a timely manner by mail, letter, telephone, push notice, etc. if it is difficult to inform the user of the information subject one by one, we will take a reasonable and effective way to publish the announcement."
      },
      {
        name:
          "6.5. At the same time, we will also report the disposal of user information security incidents according to the requirements of regulatory authorities."
      },
      {
        name:
          "6.6. We will store the collected user information in the territory of the people's Republic of China. If we need to transmit personal information abroad due to business needs in accordance with applicable laws and regulations, we will obtain your consent in advance and inform you of the purpose, receiver, security measures, security risks, etc. of the user information leaving the country."
      },
      {
        name:
          "6.7. In the event that Tesuch network products and services stop operating, we will take reasonable measures to protect your user information security, including stopping the activities of collecting user information in a timely manner; the notice of stopping operation will be sent to users one by one or announced; and the personal information held will be deleted or anonymous."
      }
    ],
    eight: "7、Special agreement on minor user information",
    eight_list: [
      {
        name:
          "7.1.We mainly provide products and services for adults. If you are a minor, we ask you to ask your parents or guardians to read this privacy policy carefully and use our services or provide us with information with the consent of your parents or guardians."
      },
      {
        name:
          "7.2.In the case of collecting personal information of minors by using our products or services with the consent of our parents or guardians, we will only use, share, transfer or disclose this information when permitted by laws and regulations, expressly agreed by our parents or guardians or necessary for the protection of minors."
      }
    ],
    nine: "8、Update of privacy policy",
    nine_list: [
      {
        name: " 8.1. Our privacy policy may be revised."
      },
      {
        name:
          "8.2. Without your express consent, we will not limit your rights under this privacy policy. Any changes to the privacy policy will be posted on a dedicated page."
      },
      {
        name:
          "8.3. For major revisions, we will also provide more significant notice (including for some services, we will notify you through website publicity or even provide you with pop-up prompts to explain the specific changes of privacy policy)."
      },
      {
        name: "8.4. Major changes referred to in this policy include but are not limited to:"
      },
      {
        name:
          "8.4.1. Our service model has changed dramatically. For example, the purpose of processing user information, the type of user information processed, and the way of using user information, etc;"
      },
      {
        name:
          " 8.4.2. We have made significant changes in control, organizational structure, etc. Such as business adjustment, bankruptcy merger and acquisition, etc;"
      },
      {
        name: "8.4.3.The main objects of user information sharing, transfer or public disclosure have changed;"
      },
      {
        name: "8.4.4. Your right to participate in user information processing and the way you exercise it have changed significantly;"
      },
      {
        name:
          "8.4.5. When the responsible department, contact information and complaint channel for handling user information security change;"
      },
      {
        name: "8.4.6. When the user information security impact assessment report indicates that there is a high risk."
      },
    ],
    ten: "9、How to contact us",
    ten_list: [
      {
        name:
          "If you have any questions and comments on the content of this statement and policy, or you have any questions and comments on the practice and operation of this privacy policy of Tesuch network, you can contact us through the work order and suggestion submission platform of Tesuch network."
      }
    ]
  },
  ...enLocale
};

export default en;
